/**
 * Generated by orval 🍺
 * Do not edit manually.
 * StockVol
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BeltImported,
  BeltIn,
  BeltOut,
  BeltParams,
  BlocksGeometryParams,
  BlocksOut,
  BodyFloorImport,
  BodyImportBelt,
  BodyImportLab,
  ChangeOut,
  CommandOut,
  ConfigApplied,
  ConfigIn,
  ConfigOut,
  ConfirmMetadataIn,
  DensityIn,
  DensityOut,
  DensityParams,
  EditPileParams,
  EventOut,
  EventsParams,
  FloorAcceptIn,
  FloorOut,
  FloorParams,
  HTTPValidationError,
  Healthz200,
  LabImported,
  LabIn,
  LabOut,
  LabParams,
  LoginIn,
  MaskOverridesIn,
  Me,
  NotifyTestOut,
  OperationsLogParams,
  OpsIn,
  OpsLogOut,
  PageBeltOut,
  PageEventOut,
  PageLabOut,
  PageOpsLogOut,
  PageReportOut,
  PageRunOut,
  PageSweepOut,
  PileDensityParams,
  PileEdit,
  PileEdited,
  PileHistory,
  PileObsOut,
  PileOut,
  PileParams,
  PilesParams,
  RasterParams,
  ReclaimedCoalParams,
  ReclaimedOut,
  ReportIn,
  ReportOut,
  ReportsParams,
  ReprocessIn,
  Reprocessed,
  RunBrief,
  RunOut,
  RunPilesParams,
  RunsParams,
  SiteOut,
  Stacker,
  StackerIn,
  StatusOut,
  SweepDetail,
  SweepRequestIn,
  SweepsParams,
  TrendPoint,
  TrendsParams,
  UserEdit,
  UserIn,
  UserOut,
  Version200,
  VolumeOut,
  VolumesParams
} from './model';

import { apiFetch } from '../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type notifyTestResponse200 = {
  data: NotifyTestOut
  status: 200
}

export type notifyTestResponseSuccess = (notifyTestResponse200) & {
  headers: Headers;
};
;

export type notifyTestResponse = (notifyTestResponseSuccess)

export const getNotifyTestUrl = () => {




  return `/api/admin/notify-test`
}

/**
 * Send a test mail to the configured recipients.
 * @summary Notify Test
 */
export const notifyTest = async ( options?: Parameters<typeof apiFetch>[1]): Promise<notifyTestResponse> => {

  return apiFetch<notifyTestResponse>(getNotifyTestUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getNotifyTestMutationKey = () => ['notifyTest'] as const;

export const getNotifyTestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyTest>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof notifyTest>>, TError,void, TContext> => {

const mutationKey = getNotifyTestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyTest>>, void> = () => {


          return  notifyTest(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotifyTestMutationResult = NonNullable<Awaited<ReturnType<typeof notifyTest>>>

    export type NotifyTestMutationError = unknown


    /**
 * @summary Notify Test
 */
export const useNotifyTest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyTest>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notifyTest>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getNotifyTestMutationOptions(options), queryClient);
    }

export type reprocessResponse201 = {
  data: Reprocessed
  status: 201
}

export type reprocessResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reprocessResponseSuccess = (reprocessResponse201) & {
  headers: Headers;
};
export type reprocessResponseError = (reprocessResponse422) & {
  headers: Headers;
};

export type reprocessResponse = (reprocessResponseSuccess | reprocessResponseError)

export const getReprocessUrl = () => {




  return `/api/admin/reprocess`
}

/**
 * Priority-10 runs for every complete or partial sweep of [t_from, t_to) — with the active
 * config and floor; the results supersede the current ones as they finish.
 * @summary Reprocess
 */
export const reprocess = async (reprocessIn: ReprocessIn, options?: Parameters<typeof apiFetch>[1]): Promise<reprocessResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<reprocessResponse>(getReprocessUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reprocessIn)
  }
);}





export const getReprocessMutationKey = () => ['reprocess'] as const;

export const getReprocessMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reprocess>>, TError,ReprocessMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reprocess>>, TError,ReprocessMutationVariables, TContext> => {

const mutationKey = getReprocessMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reprocess>>, ReprocessMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reprocess(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReprocessMutationResult = NonNullable<Awaited<ReturnType<typeof reprocess>>>
    export type ReprocessMutationBody = ReprocessIn
    export type ReprocessMutationError = HTTPValidationError
    export type ReprocessMutationVariables = {data: ReprocessIn}

    /**
 * @summary Reprocess
 */
export const useReprocess = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reprocess>>, TError,ReprocessMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reprocess>>,
        TError,
        ReprocessMutationVariables,
        TContext
      > => {
      return useMutation(getReprocessMutationOptions(options), queryClient);
    }

export type loginResponse200 = {
  data: Me
  status: 200
}

export type loginResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type loginResponseSuccess = (loginResponse200) & {
  headers: Headers;
};
export type loginResponseError = (loginResponse422) & {
  headers: Headers;
};

export type loginResponse = (loginResponseSuccess | loginResponseError)

export const getLoginUrl = () => {




  return `/api/auth/login`
}

/**
 * @summary Login
 */
export const login = async (loginIn: LoginIn, options?: Parameters<typeof apiFetch>[1]): Promise<loginResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<loginResponse>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(loginIn)
  }
);}





export const getLoginMutationKey = () => ['login'] as const;

export const getLoginMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext> => {

const mutationKey = getLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, LoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginIn
    export type LoginMutationError = HTTPValidationError
    export type LoginMutationVariables = {data: LoginIn}

    /**
 * @summary Login
 */
export const useLogin = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        LoginMutationVariables,
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }

export type logoutResponse204 = {
  data: void
  status: 204
}

export type logoutResponseSuccess = (logoutResponse204) & {
  headers: Headers;
};
;

export type logoutResponse = (logoutResponseSuccess)

export const getLogoutUrl = () => {




  return `/api/auth/logout`
}

/**
 * @summary Logout
 */
export const logout = async ( options?: Parameters<typeof apiFetch>[1]): Promise<logoutResponse> => {

  return apiFetch<logoutResponse>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutMutationKey = () => ['logout'] as const;

export const getLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = getLogoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = unknown


    /**
 * @summary Logout
 */
export const useLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options), queryClient);
    }

export type meResponse200 = {
  data: Me
  status: 200
}

export type meResponseSuccess = (meResponse200) & {
  headers: Headers;
};
;

export type meResponse = (meResponseSuccess)

export const getMeUrl = () => {




  return `/api/auth/me`
}

/**
 * @summary Me
 */
export const me = async ( options?: Parameters<typeof apiFetch>[1]): Promise<meResponse> => {

  return apiFetch<meResponse>(getMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getMeQueryOptions = <TData = Awaited<ReturnType<typeof me>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof me>>> = ({ signal }) => me({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeQueryResult = NonNullable<Awaited<ReturnType<typeof me>>>
export type MeQueryError = unknown


export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof me>>,
          TError,
          Awaited<ReturnType<typeof me>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof me>>,
          TError,
          Awaited<ReturnType<typeof me>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Me
 */

export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type beltResponse200 = {
  data: PageBeltOut
  status: 200
}

export type beltResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type beltResponseSuccess = (beltResponse200) & {
  headers: Headers;
};
export type beltResponseError = (beltResponse422) & {
  headers: Headers;
};

export type beltResponse = (beltResponseSuccess | beltResponseError)

export const getBeltUrl = (params?: BeltParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/belt?${stringifiedParams}` : `/api/belt`
}

/**
 * @summary Belt
 */
export const belt = async (params?: BeltParams, options?: Parameters<typeof apiFetch>[1]): Promise<beltResponse> => {

  return apiFetch<beltResponse>(getBeltUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBeltQueryKey = (params?: BeltParams,) => {
    return [
    `/api/belt`, ...(params ? [params] : [])
    ] as const;
    }


export const getBeltQueryOptions = <TData = Awaited<ReturnType<typeof belt>>, TError = HTTPValidationError>(params?: BeltParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof belt>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBeltQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof belt>>> = ({ signal }) => belt(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof belt>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BeltQueryResult = NonNullable<Awaited<ReturnType<typeof belt>>>
export type BeltQueryError = HTTPValidationError


export function useBelt<TData = Awaited<ReturnType<typeof belt>>, TError = HTTPValidationError>(
 params: undefined |  BeltParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof belt>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof belt>>,
          TError,
          Awaited<ReturnType<typeof belt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBelt<TData = Awaited<ReturnType<typeof belt>>, TError = HTTPValidationError>(
 params?: BeltParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof belt>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof belt>>,
          TError,
          Awaited<ReturnType<typeof belt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBelt<TData = Awaited<ReturnType<typeof belt>>, TError = HTTPValidationError>(
 params?: BeltParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof belt>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Belt
 */

export function useBelt<TData = Awaited<ReturnType<typeof belt>>, TError = HTTPValidationError>(
 params?: BeltParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof belt>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBeltQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type addBeltResponse201 = {
  data: BeltOut
  status: 201
}

export type addBeltResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type addBeltResponseSuccess = (addBeltResponse201) & {
  headers: Headers;
};
export type addBeltResponseError = (addBeltResponse422) & {
  headers: Headers;
};

export type addBeltResponse = (addBeltResponseSuccess | addBeltResponseError)

export const getAddBeltUrl = () => {




  return `/api/belt`
}

/**
 * @summary Add Belt
 */
export const addBelt = async (beltIn: BeltIn, options?: Parameters<typeof apiFetch>[1]): Promise<addBeltResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<addBeltResponse>(getAddBeltUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(beltIn)
  }
);}





export const getAddBeltMutationKey = () => ['addBelt'] as const;

export const getAddBeltMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addBelt>>, TError,AddBeltMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addBelt>>, TError,AddBeltMutationVariables, TContext> => {

const mutationKey = getAddBeltMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addBelt>>, AddBeltMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addBelt(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddBeltMutationResult = NonNullable<Awaited<ReturnType<typeof addBelt>>>
    export type AddBeltMutationBody = BeltIn
    export type AddBeltMutationError = HTTPValidationError
    export type AddBeltMutationVariables = {data: BeltIn}

    /**
 * @summary Add Belt
 */
export const useAddBelt = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addBelt>>, TError,AddBeltMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addBelt>>,
        TError,
        AddBeltMutationVariables,
        TContext
      > => {
      return useMutation(getAddBeltMutationOptions(options), queryClient);
    }

export type importBeltResponse201 = {
  data: BeltImported
  status: 201
}

export type importBeltResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type importBeltResponseSuccess = (importBeltResponse201) & {
  headers: Headers;
};
export type importBeltResponseError = (importBeltResponse422) & {
  headers: Headers;
};

export type importBeltResponse = (importBeltResponseSuccess | importBeltResponseError)

export const getImportBeltUrl = () => {




  return `/api/belt/import`
}

/**
 * A CSV of belt tonnes; any bad row → 422 with every bad line, nothing imported.
 * @summary Import Belt
 */
export const importBelt = async (bodyImportBelt: BodyImportBelt, options?: Parameters<typeof apiFetch>[1]): Promise<importBeltResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyImportBelt.file);

  return apiFetch<importBeltResponse>(getImportBeltUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getImportBeltMutationKey = () => ['importBelt'] as const;

export const getImportBeltMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importBelt>>, TError,ImportBeltMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importBelt>>, TError,ImportBeltMutationVariables, TContext> => {

const mutationKey = getImportBeltMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importBelt>>, ImportBeltMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  importBelt(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportBeltMutationResult = NonNullable<Awaited<ReturnType<typeof importBelt>>>
    export type ImportBeltMutationBody = BodyImportBelt
    export type ImportBeltMutationError = HTTPValidationError
    export type ImportBeltMutationVariables = {data: BodyImportBelt}

    /**
 * @summary Import Belt
 */
export const useImportBelt = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importBelt>>, TError,ImportBeltMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importBelt>>,
        TError,
        ImportBeltMutationVariables,
        TContext
      > => {
      return useMutation(getImportBeltMutationOptions(options), queryClient);
    }

export type deleteBeltResponse204 = {
  data: void
  status: 204
}

export type deleteBeltResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteBeltResponseSuccess = (deleteBeltResponse204) & {
  headers: Headers;
};
export type deleteBeltResponseError = (deleteBeltResponse422) & {
  headers: Headers;
};

export type deleteBeltResponse = (deleteBeltResponseSuccess | deleteBeltResponseError)

export const getDeleteBeltUrl = (readingId: number,) => {




  return `/api/belt/${readingId}`
}

/**
 * @summary Delete Belt
 */
export const deleteBelt = async (readingId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteBeltResponse> => {

  return apiFetch<deleteBeltResponse>(getDeleteBeltUrl(readingId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteBeltMutationKey = () => ['deleteBelt'] as const;

export const getDeleteBeltMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBelt>>, TError,DeleteBeltMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBelt>>, TError,DeleteBeltMutationVariables, TContext> => {

const mutationKey = getDeleteBeltMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBelt>>, DeleteBeltMutationVariables> = (props) => {
          const {readingId} = props ?? {};

          return  deleteBelt(readingId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBeltMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBelt>>>

    export type DeleteBeltMutationError = HTTPValidationError
    export type DeleteBeltMutationVariables = {readingId: number}

    /**
 * @summary Delete Belt
 */
export const useDeleteBelt = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBelt>>, TError,DeleteBeltMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBelt>>,
        TError,
        DeleteBeltMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteBeltMutationOptions(options), queryClient);
    }

export type configResponse200 = {
  data: ConfigOut
  status: 200
}

export type configResponseSuccess = (configResponse200) & {
  headers: Headers;
};
;

export type configResponse = (configResponseSuccess)

export const getConfigUrl = () => {




  return `/api/config`
}

/**
 * The active site configuration with its YAML.
 * @summary Config
 */
export const config = async ( options?: Parameters<typeof apiFetch>[1]): Promise<configResponse> => {

  return apiFetch<configResponse>(getConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getConfigQueryKey = () => {
    return [
    `/api/config`
    ] as const;
    }


export const getConfigQueryOptions = <TData = Awaited<ReturnType<typeof config>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof config>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof config>>> = ({ signal }) => config({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof config>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConfigQueryResult = NonNullable<Awaited<ReturnType<typeof config>>>
export type ConfigQueryError = unknown


export function useConfig<TData = Awaited<ReturnType<typeof config>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof config>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof config>>,
          TError,
          Awaited<ReturnType<typeof config>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConfig<TData = Awaited<ReturnType<typeof config>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof config>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof config>>,
          TError,
          Awaited<ReturnType<typeof config>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConfig<TData = Awaited<ReturnType<typeof config>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof config>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Config
 */

export function useConfig<TData = Awaited<ReturnType<typeof config>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof config>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type putConfigResponse200 = {
  data: ConfigApplied
  status: 200
}

export type putConfigResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type putConfigResponseSuccess = (putConfigResponse200) & {
  headers: Headers;
};
export type putConfigResponseError = (putConfigResponse422) & {
  headers: Headers;
};

export type putConfigResponse = (putConfigResponseSuccess | putConfigResponseError)

export const getPutConfigUrl = () => {




  return `/api/config`
}

/**
 * Validate, hash and activate a site config (the worker reads it at the next run's start).
 * Invalid YAML or values → 422 and the active config stays.
 * @summary Put Config
 */
export const putConfig = async (configIn: ConfigIn, options?: Parameters<typeof apiFetch>[1]): Promise<putConfigResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<putConfigResponse>(getPutConfigUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(configIn)
  }
);}





export const getPutConfigMutationKey = () => ['putConfig'] as const;

export const getPutConfigMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putConfig>>, TError,PutConfigMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putConfig>>, TError,PutConfigMutationVariables, TContext> => {

const mutationKey = getPutConfigMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putConfig>>, PutConfigMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putConfig(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutConfigMutationResult = NonNullable<Awaited<ReturnType<typeof putConfig>>>
    export type PutConfigMutationBody = ConfigIn
    export type PutConfigMutationError = HTTPValidationError
    export type PutConfigMutationVariables = {data: ConfigIn}

    /**
 * @summary Put Config
 */
export const usePutConfig = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putConfig>>, TError,PutConfigMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putConfig>>,
        TError,
        PutConfigMutationVariables,
        TContext
      > => {
      return useMutation(getPutConfigMutationOptions(options), queryClient);
    }

export type configVersionsResponse200 = {
  data: ConfigOut[]
  status: 200
}

export type configVersionsResponseSuccess = (configVersionsResponse200) & {
  headers: Headers;
};
;

export type configVersionsResponse = (configVersionsResponseSuccess)

export const getConfigVersionsUrl = () => {




  return `/api/config/versions`
}

/**
 * @summary Config Versions
 */
export const configVersions = async ( options?: Parameters<typeof apiFetch>[1]): Promise<configVersionsResponse> => {

  return apiFetch<configVersionsResponse>(getConfigVersionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getConfigVersionsQueryKey = () => {
    return [
    `/api/config/versions`
    ] as const;
    }


export const getConfigVersionsQueryOptions = <TData = Awaited<ReturnType<typeof configVersions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configVersions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigVersionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof configVersions>>> = ({ signal }) => configVersions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof configVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConfigVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof configVersions>>>
export type ConfigVersionsQueryError = unknown


export function useConfigVersions<TData = Awaited<ReturnType<typeof configVersions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof configVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof configVersions>>,
          TError,
          Awaited<ReturnType<typeof configVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConfigVersions<TData = Awaited<ReturnType<typeof configVersions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof configVersions>>,
          TError,
          Awaited<ReturnType<typeof configVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConfigVersions<TData = Awaited<ReturnType<typeof configVersions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configVersions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Config Versions
 */

export function useConfigVersions<TData = Awaited<ReturnType<typeof configVersions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configVersions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConfigVersionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type densityResponse200 = {
  data: DensityOut[]
  status: 200
}

export type densityResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type densityResponseSuccess = (densityResponse200) & {
  headers: Headers;
};
export type densityResponseError = (densityResponse422) & {
  headers: Headers;
};

export type densityResponse = (densityResponseSuccess | densityResponseError)

export const getDensityUrl = (params?: DensityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/density?${stringifiedParams}` : `/api/density`
}

/**
 * @summary Density
 */
export const density = async (params?: DensityParams, options?: Parameters<typeof apiFetch>[1]): Promise<densityResponse> => {

  return apiFetch<densityResponse>(getDensityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDensityQueryKey = (params?: DensityParams,) => {
    return [
    `/api/density`, ...(params ? [params] : [])
    ] as const;
    }


export const getDensityQueryOptions = <TData = Awaited<ReturnType<typeof density>>, TError = HTTPValidationError>(params?: DensityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof density>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDensityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof density>>> = ({ signal }) => density(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof density>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DensityQueryResult = NonNullable<Awaited<ReturnType<typeof density>>>
export type DensityQueryError = HTTPValidationError


export function useDensity<TData = Awaited<ReturnType<typeof density>>, TError = HTTPValidationError>(
 params: undefined |  DensityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof density>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof density>>,
          TError,
          Awaited<ReturnType<typeof density>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDensity<TData = Awaited<ReturnType<typeof density>>, TError = HTTPValidationError>(
 params?: DensityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof density>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof density>>,
          TError,
          Awaited<ReturnType<typeof density>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDensity<TData = Awaited<ReturnType<typeof density>>, TError = HTTPValidationError>(
 params?: DensityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof density>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Density
 */

export function useDensity<TData = Awaited<ReturnType<typeof density>>, TError = HTTPValidationError>(
 params?: DensityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof density>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDensityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type eventsResponse200 = {
  data: PageEventOut
  status: 200
}

export type eventsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type eventsResponseSuccess = (eventsResponse200) & {
  headers: Headers;
};
export type eventsResponseError = (eventsResponse422) & {
  headers: Headers;
};

export type eventsResponse = (eventsResponseSuccess | eventsResponseError)

export const getEventsUrl = (params?: EventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/events?${stringifiedParams}` : `/api/events`
}

/**
 * Newest first. `open_only`: neither acknowledged nor resolved.
 * @summary Events
 */
export const events = async (params?: EventsParams, options?: Parameters<typeof apiFetch>[1]): Promise<eventsResponse> => {

  return apiFetch<eventsResponse>(getEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEventsQueryKey = (params?: EventsParams,) => {
    return [
    `/api/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getEventsQueryOptions = <TData = Awaited<ReturnType<typeof events>>, TError = HTTPValidationError>(params?: EventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof events>>> = ({ signal }) => events(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventsQueryResult = NonNullable<Awaited<ReturnType<typeof events>>>
export type EventsQueryError = HTTPValidationError


export function useEvents<TData = Awaited<ReturnType<typeof events>>, TError = HTTPValidationError>(
 params: undefined |  EventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof events>>,
          TError,
          Awaited<ReturnType<typeof events>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEvents<TData = Awaited<ReturnType<typeof events>>, TError = HTTPValidationError>(
 params?: EventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof events>>,
          TError,
          Awaited<ReturnType<typeof events>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEvents<TData = Awaited<ReturnType<typeof events>>, TError = HTTPValidationError>(
 params?: EventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Events
 */

export function useEvents<TData = Awaited<ReturnType<typeof events>>, TError = HTTPValidationError>(
 params?: EventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type ackEventResponse200 = {
  data: EventOut
  status: 200
}

export type ackEventResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type ackEventResponseSuccess = (ackEventResponse200) & {
  headers: Headers;
};
export type ackEventResponseError = (ackEventResponse422) & {
  headers: Headers;
};

export type ackEventResponse = (ackEventResponseSuccess | ackEventResponseError)

export const getAckEventUrl = (eventId: number,) => {




  return `/api/events/${eventId}/ack`
}

/**
 * @summary Ack Event
 */
export const ackEvent = async (eventId: number, options?: Parameters<typeof apiFetch>[1]): Promise<ackEventResponse> => {

  return apiFetch<ackEventResponse>(getAckEventUrl(eventId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAckEventMutationKey = () => ['ackEvent'] as const;

export const getAckEventMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ackEvent>>, TError,AckEventMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof ackEvent>>, TError,AckEventMutationVariables, TContext> => {

const mutationKey = getAckEventMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ackEvent>>, AckEventMutationVariables> = (props) => {
          const {eventId} = props ?? {};

          return  ackEvent(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AckEventMutationResult = NonNullable<Awaited<ReturnType<typeof ackEvent>>>

    export type AckEventMutationError = HTTPValidationError
    export type AckEventMutationVariables = {eventId: number}

    /**
 * @summary Ack Event
 */
export const useAckEvent = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ackEvent>>, TError,AckEventMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ackEvent>>,
        TError,
        AckEventMutationVariables,
        TContext
      > => {
      return useMutation(getAckEventMutationOptions(options), queryClient);
    }

export type floorResponse200 = {
  data: FloorOut[]
  status: 200
}

export type floorResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type floorResponseSuccess = (floorResponse200) & {
  headers: Headers;
};
export type floorResponseError = (floorResponse422) & {
  headers: Headers;
};

export type floorResponse = (floorResponseSuccess | floorResponseError)

export const getFloorUrl = (params?: FloorParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/floor?${stringifiedParams}` : `/api/floor`
}

/**
 * Every floor version, the active one flagged; newest first.
 * @summary Floor
 */
export const floor = async (params?: FloorParams, options?: Parameters<typeof apiFetch>[1]): Promise<floorResponse> => {

  return apiFetch<floorResponse>(getFloorUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFloorQueryKey = (params?: FloorParams,) => {
    return [
    `/api/floor`, ...(params ? [params] : [])
    ] as const;
    }


export const getFloorQueryOptions = <TData = Awaited<ReturnType<typeof floor>>, TError = HTTPValidationError>(params?: FloorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFloorQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof floor>>> = ({ signal }) => floor(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FloorQueryResult = NonNullable<Awaited<ReturnType<typeof floor>>>
export type FloorQueryError = HTTPValidationError


export function useFloor<TData = Awaited<ReturnType<typeof floor>>, TError = HTTPValidationError>(
 params: undefined |  FloorParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof floor>>,
          TError,
          Awaited<ReturnType<typeof floor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFloor<TData = Awaited<ReturnType<typeof floor>>, TError = HTTPValidationError>(
 params?: FloorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof floor>>,
          TError,
          Awaited<ReturnType<typeof floor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFloor<TData = Awaited<ReturnType<typeof floor>>, TError = HTTPValidationError>(
 params?: FloorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Floor
 */

export function useFloor<TData = Awaited<ReturnType<typeof floor>>, TError = HTTPValidationError>(
 params?: FloorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFloorQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type floorAcceptResponse201 = {
  data: FloorOut
  status: 201
}

export type floorAcceptResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type floorAcceptResponseSuccess = (floorAcceptResponse201) & {
  headers: Headers;
};
export type floorAcceptResponseError = (floorAcceptResponse422) & {
  headers: Headers;
};

export type floorAcceptResponse = (floorAcceptResponseSuccess | floorAcceptResponseError)

export const getFloorAcceptUrl = () => {




  return `/api/floor/accept`
}

/**
 * The floor model's candidate (or the latest observed floor) becomes the next version.
 * @summary Floor Accept
 */
export const floorAccept = async (floorAcceptIn: FloorAcceptIn, options?: Parameters<typeof apiFetch>[1]): Promise<floorAcceptResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<floorAcceptResponse>(getFloorAcceptUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(floorAcceptIn)
  }
);}





export const getFloorAcceptMutationKey = () => ['floorAccept'] as const;

export const getFloorAcceptMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof floorAccept>>, TError,FloorAcceptMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof floorAccept>>, TError,FloorAcceptMutationVariables, TContext> => {

const mutationKey = getFloorAcceptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof floorAccept>>, FloorAcceptMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  floorAccept(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FloorAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof floorAccept>>>
    export type FloorAcceptMutationBody = FloorAcceptIn
    export type FloorAcceptMutationError = HTTPValidationError
    export type FloorAcceptMutationVariables = {data: FloorAcceptIn}

    /**
 * @summary Floor Accept
 */
export const useFloorAccept = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof floorAccept>>, TError,FloorAcceptMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof floorAccept>>,
        TError,
        FloorAcceptMutationVariables,
        TContext
      > => {
      return useMutation(getFloorAcceptMutationOptions(options), queryClient);
    }

export type floorImportResponse201 = {
  data: FloorOut
  status: 201
}

export type floorImportResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type floorImportResponseSuccess = (floorImportResponse201) & {
  headers: Headers;
};
export type floorImportResponseError = (floorImportResponse422) & {
  headers: Headers;
};

export type floorImportResponse = (floorImportResponseSuccess | floorImportResponseError)

export const getFloorImportUrl = () => {




  return `/api/floor/import`
}

/**
 * A surveyed floor (GeoTIFF of elevations, any CRS) becomes the next floor version.
 * @summary Floor Import
 */
export const floorImport = async (bodyFloorImport: BodyFloorImport, options?: Parameters<typeof apiFetch>[1]): Promise<floorImportResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyFloorImport.file);

  return apiFetch<floorImportResponse>(getFloorImportUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getFloorImportMutationKey = () => ['floorImport'] as const;

export const getFloorImportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof floorImport>>, TError,FloorImportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof floorImport>>, TError,FloorImportMutationVariables, TContext> => {

const mutationKey = getFloorImportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof floorImport>>, FloorImportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  floorImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FloorImportMutationResult = NonNullable<Awaited<ReturnType<typeof floorImport>>>
    export type FloorImportMutationBody = BodyFloorImport
    export type FloorImportMutationError = HTTPValidationError
    export type FloorImportMutationVariables = {data: BodyFloorImport}

    /**
 * @summary Floor Import
 */
export const useFloorImport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof floorImport>>, TError,FloorImportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof floorImport>>,
        TError,
        FloorImportMutationVariables,
        TContext
      > => {
      return useMutation(getFloorImportMutationOptions(options), queryClient);
    }

export type healthzResponse200 = {
  data: Healthz200
  status: 200
}

export type healthzResponseSuccess = (healthzResponse200) & {
  headers: Headers;
};
;

export type healthzResponse = (healthzResponseSuccess)

export const getHealthzUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Healthz
 */
export const healthz = async ( options?: Parameters<typeof apiFetch>[1]): Promise<healthzResponse> => {

  return apiFetch<healthzResponse>(getHealthzUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthzQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthzQueryOptions = <TData = Awaited<ReturnType<typeof healthz>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthz>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthzQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthz>>> = ({ signal }) => healthz({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthz>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthzQueryResult = NonNullable<Awaited<ReturnType<typeof healthz>>>
export type HealthzQueryError = unknown


export function useHealthz<TData = Awaited<ReturnType<typeof healthz>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthz>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthz>>,
          TError,
          Awaited<ReturnType<typeof healthz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthz<TData = Awaited<ReturnType<typeof healthz>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthz>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthz>>,
          TError,
          Awaited<ReturnType<typeof healthz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthz<TData = Awaited<ReturnType<typeof healthz>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthz>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Healthz
 */

export function useHealthz<TData = Awaited<ReturnType<typeof healthz>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthz>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthzQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type labResponse200 = {
  data: PageLabOut
  status: 200
}

export type labResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type labResponseSuccess = (labResponse200) & {
  headers: Headers;
};
export type labResponseError = (labResponse422) & {
  headers: Headers;
};

export type labResponse = (labResponseSuccess | labResponseError)

export const getLabUrl = (params?: LabParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/lab?${stringifiedParams}` : `/api/lab`
}

/**
 * The live lab results, newest cycle first.
 * @summary Lab
 */
export const lab = async (params?: LabParams, options?: Parameters<typeof apiFetch>[1]): Promise<labResponse> => {

  return apiFetch<labResponse>(getLabUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLabQueryKey = (params?: LabParams,) => {
    return [
    `/api/lab`, ...(params ? [params] : [])
    ] as const;
    }


export const getLabQueryOptions = <TData = Awaited<ReturnType<typeof lab>>, TError = HTTPValidationError>(params?: LabParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lab>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLabQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lab>>> = ({ signal }) => lab(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lab>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LabQueryResult = NonNullable<Awaited<ReturnType<typeof lab>>>
export type LabQueryError = HTTPValidationError


export function useLab<TData = Awaited<ReturnType<typeof lab>>, TError = HTTPValidationError>(
 params: undefined |  LabParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lab>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lab>>,
          TError,
          Awaited<ReturnType<typeof lab>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLab<TData = Awaited<ReturnType<typeof lab>>, TError = HTTPValidationError>(
 params?: LabParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lab>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lab>>,
          TError,
          Awaited<ReturnType<typeof lab>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLab<TData = Awaited<ReturnType<typeof lab>>, TError = HTTPValidationError>(
 params?: LabParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lab>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lab
 */

export function useLab<TData = Awaited<ReturnType<typeof lab>>, TError = HTTPValidationError>(
 params?: LabParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lab>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLabQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type addLabResponse201 = {
  data: LabOut
  status: 201
}

export type addLabResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type addLabResponseSuccess = (addLabResponse201) & {
  headers: Headers;
};
export type addLabResponseError = (addLabResponse422) & {
  headers: Headers;
};

export type addLabResponse = (addLabResponseSuccess | addLabResponseError)

export const getAddLabUrl = () => {




  return `/api/lab`
}

/**
 * One cycle's result; a result for the same cycle (and product) is replaced.
 * @summary Add Lab
 */
export const addLab = async (labIn: LabIn, options?: Parameters<typeof apiFetch>[1]): Promise<addLabResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<addLabResponse>(getAddLabUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(labIn)
  }
);}





export const getAddLabMutationKey = () => ['addLab'] as const;

export const getAddLabMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLab>>, TError,AddLabMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addLab>>, TError,AddLabMutationVariables, TContext> => {

const mutationKey = getAddLabMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addLab>>, AddLabMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addLab(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddLabMutationResult = NonNullable<Awaited<ReturnType<typeof addLab>>>
    export type AddLabMutationBody = LabIn
    export type AddLabMutationError = HTTPValidationError
    export type AddLabMutationVariables = {data: LabIn}

    /**
 * @summary Add Lab
 */
export const useAddLab = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLab>>, TError,AddLabMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addLab>>,
        TError,
        AddLabMutationVariables,
        TContext
      > => {
      return useMutation(getAddLabMutationOptions(options), queryClient);
    }

export type importLabResponse201 = {
  data: LabImported
  status: 201
}

export type importLabResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type importLabResponseSuccess = (importLabResponse201) & {
  headers: Headers;
};
export type importLabResponseError = (importLabResponse422) & {
  headers: Headers;
};

export type importLabResponse = (importLabResponseSuccess | importLabResponseError)

export const getImportLabUrl = () => {




  return `/api/lab/import`
}

/**
 * A CSV of lab results; a cycle that already has a result is replaced. Any bad row → 422 with
 * every bad line, nothing imported.
 * @summary Import Lab
 */
export const importLab = async (bodyImportLab: BodyImportLab, options?: Parameters<typeof apiFetch>[1]): Promise<importLabResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyImportLab.file);

  return apiFetch<importLabResponse>(getImportLabUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getImportLabMutationKey = () => ['importLab'] as const;

export const getImportLabMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importLab>>, TError,ImportLabMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importLab>>, TError,ImportLabMutationVariables, TContext> => {

const mutationKey = getImportLabMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importLab>>, ImportLabMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  importLab(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportLabMutationResult = NonNullable<Awaited<ReturnType<typeof importLab>>>
    export type ImportLabMutationBody = BodyImportLab
    export type ImportLabMutationError = HTTPValidationError
    export type ImportLabMutationVariables = {data: BodyImportLab}

    /**
 * @summary Import Lab
 */
export const useImportLab = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importLab>>, TError,ImportLabMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importLab>>,
        TError,
        ImportLabMutationVariables,
        TContext
      > => {
      return useMutation(getImportLabMutationOptions(options), queryClient);
    }

export type deleteLabResponse204 = {
  data: void
  status: 204
}

export type deleteLabResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteLabResponseSuccess = (deleteLabResponse204) & {
  headers: Headers;
};
export type deleteLabResponseError = (deleteLabResponse422) & {
  headers: Headers;
};

export type deleteLabResponse = (deleteLabResponseSuccess | deleteLabResponseError)

export const getDeleteLabUrl = (labId: number,) => {




  return `/api/lab/${labId}`
}

/**
 * @summary Delete Lab
 */
export const deleteLab = async (labId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteLabResponse> => {

  return apiFetch<deleteLabResponse>(getDeleteLabUrl(labId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLabMutationKey = () => ['deleteLab'] as const;

export const getDeleteLabMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLab>>, TError,DeleteLabMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLab>>, TError,DeleteLabMutationVariables, TContext> => {

const mutationKey = getDeleteLabMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLab>>, DeleteLabMutationVariables> = (props) => {
          const {labId} = props ?? {};

          return  deleteLab(labId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLabMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLab>>>

    export type DeleteLabMutationError = HTTPValidationError
    export type DeleteLabMutationVariables = {labId: number}

    /**
 * @summary Delete Lab
 */
export const useDeleteLab = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLab>>, TError,DeleteLabMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLab>>,
        TError,
        DeleteLabMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteLabMutationOptions(options), queryClient);
    }

export type metricsResponse200 = {
  data: unknown
  status: 200
}

export type metricsResponseSuccess = (metricsResponse200) & {
  headers: Headers;
};
;

export type metricsResponse = (metricsResponseSuccess)

export const getMetricsUrl = () => {




  return `/api/metrics`
}

/**
 * @summary Metrics
 */
export const metrics = async ( options?: Parameters<typeof apiFetch>[1]): Promise<metricsResponse> => {

  return apiFetch<metricsResponse>(getMetricsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMetricsQueryKey = () => {
    return [
    `/api/metrics`
    ] as const;
    }


export const getMetricsQueryOptions = <TData = Awaited<ReturnType<typeof metrics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof metrics>>> = ({ signal }) => metrics({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetricsQueryResult = NonNullable<Awaited<ReturnType<typeof metrics>>>
export type MetricsQueryError = unknown


export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metrics>>,
          TError,
          Awaited<ReturnType<typeof metrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metrics>>,
          TError,
          Awaited<ReturnType<typeof metrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Metrics
 */

export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetricsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type operationsLogResponse200 = {
  data: PageOpsLogOut
  status: 200
}

export type operationsLogResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type operationsLogResponseSuccess = (operationsLogResponse200) & {
  headers: Headers;
};
export type operationsLogResponseError = (operationsLogResponse422) & {
  headers: Headers;
};

export type operationsLogResponse = (operationsLogResponseSuccess | operationsLogResponseError)

export const getOperationsLogUrl = (params?: OperationsLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/operations-log?${stringifiedParams}` : `/api/operations-log`
}

/**
 * @summary Operations Log
 */
export const operationsLog = async (params?: OperationsLogParams, options?: Parameters<typeof apiFetch>[1]): Promise<operationsLogResponse> => {

  return apiFetch<operationsLogResponse>(getOperationsLogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperationsLogQueryKey = (params?: OperationsLogParams,) => {
    return [
    `/api/operations-log`, ...(params ? [params] : [])
    ] as const;
    }


export const getOperationsLogQueryOptions = <TData = Awaited<ReturnType<typeof operationsLog>>, TError = HTTPValidationError>(params?: OperationsLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsLog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsLogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsLog>>> = ({ signal }) => operationsLog(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsLogQueryResult = NonNullable<Awaited<ReturnType<typeof operationsLog>>>
export type OperationsLogQueryError = HTTPValidationError


export function useOperationsLog<TData = Awaited<ReturnType<typeof operationsLog>>, TError = HTTPValidationError>(
 params: undefined |  OperationsLogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsLog>>,
          TError,
          Awaited<ReturnType<typeof operationsLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsLog<TData = Awaited<ReturnType<typeof operationsLog>>, TError = HTTPValidationError>(
 params?: OperationsLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsLog>>,
          TError,
          Awaited<ReturnType<typeof operationsLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsLog<TData = Awaited<ReturnType<typeof operationsLog>>, TError = HTTPValidationError>(
 params?: OperationsLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsLog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Operations Log
 */

export function useOperationsLog<TData = Awaited<ReturnType<typeof operationsLog>>, TError = HTTPValidationError>(
 params?: OperationsLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsLog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsLogQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type addOpsResponse201 = {
  data: OpsLogOut
  status: 201
}

export type addOpsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type addOpsResponseSuccess = (addOpsResponse201) & {
  headers: Headers;
};
export type addOpsResponseError = (addOpsResponse422) & {
  headers: Headers;
};

export type addOpsResponse = (addOpsResponseSuccess | addOpsResponseError)

export const getAddOpsUrl = () => {




  return `/api/operations-log`
}

/**
 * @summary Add Ops
 */
export const addOps = async (opsIn: OpsIn, options?: Parameters<typeof apiFetch>[1]): Promise<addOpsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<addOpsResponse>(getAddOpsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(opsIn)
  }
);}





export const getAddOpsMutationKey = () => ['addOps'] as const;

export const getAddOpsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOps>>, TError,AddOpsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addOps>>, TError,AddOpsMutationVariables, TContext> => {

const mutationKey = getAddOpsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOps>>, AddOpsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addOps(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddOpsMutationResult = NonNullable<Awaited<ReturnType<typeof addOps>>>
    export type AddOpsMutationBody = OpsIn
    export type AddOpsMutationError = HTTPValidationError
    export type AddOpsMutationVariables = {data: OpsIn}

    /**
 * @summary Add Ops
 */
export const useAddOps = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOps>>, TError,AddOpsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addOps>>,
        TError,
        AddOpsMutationVariables,
        TContext
      > => {
      return useMutation(getAddOpsMutationOptions(options), queryClient);
    }

export type deleteOpsResponse204 = {
  data: void
  status: 204
}

export type deleteOpsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteOpsResponseSuccess = (deleteOpsResponse204) & {
  headers: Headers;
};
export type deleteOpsResponseError = (deleteOpsResponse422) & {
  headers: Headers;
};

export type deleteOpsResponse = (deleteOpsResponseSuccess | deleteOpsResponseError)

export const getDeleteOpsUrl = (entryId: number,) => {




  return `/api/operations-log/${entryId}`
}

/**
 * @summary Delete Ops
 */
export const deleteOps = async (entryId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteOpsResponse> => {

  return apiFetch<deleteOpsResponse>(getDeleteOpsUrl(entryId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOpsMutationKey = () => ['deleteOps'] as const;

export const getDeleteOpsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOps>>, TError,DeleteOpsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOps>>, TError,DeleteOpsMutationVariables, TContext> => {

const mutationKey = getDeleteOpsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOps>>, DeleteOpsMutationVariables> = (props) => {
          const {entryId} = props ?? {};

          return  deleteOps(entryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOpsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOps>>>

    export type DeleteOpsMutationError = HTTPValidationError
    export type DeleteOpsMutationVariables = {entryId: number}

    /**
 * @summary Delete Ops
 */
export const useDeleteOps = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOps>>, TError,DeleteOpsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOps>>,
        TError,
        DeleteOpsMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOpsMutationOptions(options), queryClient);
    }

export type pilesResponse200 = {
  data: PileOut[]
  status: 200
}

export type pilesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type pilesResponseSuccess = (pilesResponse200) & {
  headers: Headers;
};
export type pilesResponseError = (pilesResponse422) & {
  headers: Headers;
};

export type pilesResponse = (pilesResponseSuccess | pilesResponseError)

export const getPilesUrl = (params?: PilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/piles?${stringifiedParams}` : `/api/piles`
}

/**
 * @summary Piles
 */
export const piles = async (params?: PilesParams, options?: Parameters<typeof apiFetch>[1]): Promise<pilesResponse> => {

  return apiFetch<pilesResponse>(getPilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPilesQueryKey = (params?: PilesParams,) => {
    return [
    `/api/piles`, ...(params ? [params] : [])
    ] as const;
    }


export const getPilesQueryOptions = <TData = Awaited<ReturnType<typeof piles>>, TError = HTTPValidationError>(params?: PilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof piles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof piles>>> = ({ signal }) => piles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof piles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PilesQueryResult = NonNullable<Awaited<ReturnType<typeof piles>>>
export type PilesQueryError = HTTPValidationError


export function usePiles<TData = Awaited<ReturnType<typeof piles>>, TError = HTTPValidationError>(
 params: undefined |  PilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof piles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof piles>>,
          TError,
          Awaited<ReturnType<typeof piles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePiles<TData = Awaited<ReturnType<typeof piles>>, TError = HTTPValidationError>(
 params?: PilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof piles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof piles>>,
          TError,
          Awaited<ReturnType<typeof piles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePiles<TData = Awaited<ReturnType<typeof piles>>, TError = HTTPValidationError>(
 params?: PilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof piles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Piles
 */

export function usePiles<TData = Awaited<ReturnType<typeof piles>>, TError = HTTPValidationError>(
 params?: PilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof piles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPilesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type pileResponse200 = {
  data: PileHistory
  status: 200
}

export type pileResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type pileResponseSuccess = (pileResponse200) & {
  headers: Headers;
};
export type pileResponseError = (pileResponse422) & {
  headers: Headers;
};

export type pileResponse = (pileResponseSuccess | pileResponseError)

export const getPileUrl = (code: string,
    params?: PileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/piles/${code}?${stringifiedParams}` : `/api/piles/${code}`
}

/**
 * @summary Pile
 */
export const pile = async (code: string,
    params?: PileParams, options?: Parameters<typeof apiFetch>[1]): Promise<pileResponse> => {

  return apiFetch<pileResponse>(getPileUrl(code,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPileQueryKey = (code: string,
    params?: PileParams,) => {
    return [
    `/api/piles/${code}`, ...(params ? [params] : [])
    ] as const;
    }


export const getPileQueryOptions = <TData = Awaited<ReturnType<typeof pile>>, TError = HTTPValidationError>(code: string,
    params?: PileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPileQueryKey(code,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pile>>> = ({ signal }) => pile(code,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PileQueryResult = NonNullable<Awaited<ReturnType<typeof pile>>>
export type PileQueryError = HTTPValidationError


export function usePile<TData = Awaited<ReturnType<typeof pile>>, TError = HTTPValidationError>(
 code: string,
    params: undefined |  PileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pile>>,
          TError,
          Awaited<ReturnType<typeof pile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePile<TData = Awaited<ReturnType<typeof pile>>, TError = HTTPValidationError>(
 code: string,
    params?: PileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pile>>,
          TError,
          Awaited<ReturnType<typeof pile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePile<TData = Awaited<ReturnType<typeof pile>>, TError = HTTPValidationError>(
 code: string,
    params?: PileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pile
 */

export function usePile<TData = Awaited<ReturnType<typeof pile>>, TError = HTTPValidationError>(
 code: string,
    params?: PileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPileQueryOptions(code,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type editPileResponse200 = {
  data: PileEdited
  status: 200
}

export type editPileResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type editPileResponseSuccess = (editPileResponse200) & {
  headers: Headers;
};
export type editPileResponseError = (editPileResponse422) & {
  headers: Headers;
};

export type editPileResponse = (editPileResponseSuccess | editPileResponseError)

export const getEditPileUrl = (code: string,
    params?: EditPileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/piles/${code}?${stringifiedParams}` : `/api/piles/${code}`
}

/**
 * Name a pile, set its product / blend, or mark it dormant / cleared (only the fields sent).
 * @summary Edit Pile
 */
export const editPile = async (code: string,
    pileEdit: PileEdit,
    params?: EditPileParams, options?: Parameters<typeof apiFetch>[1]): Promise<editPileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<editPileResponse>(getEditPileUrl(code,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pileEdit)
  }
);}





export const getEditPileMutationKey = () => ['editPile'] as const;

export const getEditPileMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPile>>, TError,EditPileMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editPile>>, TError,EditPileMutationVariables, TContext> => {

const mutationKey = getEditPileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPile>>, EditPileMutationVariables> = (props) => {
          const {code,data,params} = props ?? {};

          return  editPile(code,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditPileMutationResult = NonNullable<Awaited<ReturnType<typeof editPile>>>
    export type EditPileMutationBody = PileEdit
    export type EditPileMutationError = HTTPValidationError
    export type EditPileMutationVariables = {code: string;data: PileEdit;params?: EditPileParams}

    /**
 * @summary Edit Pile
 */
export const useEditPile = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPile>>, TError,EditPileMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editPile>>,
        TError,
        EditPileMutationVariables,
        TContext
      > => {
      return useMutation(getEditPileMutationOptions(options), queryClient);
    }

export type pileDensityResponse200 = {
  data: PileEdited
  status: 200
}

export type pileDensityResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type pileDensityResponseSuccess = (pileDensityResponse200) & {
  headers: Headers;
};
export type pileDensityResponseError = (pileDensityResponse422) & {
  headers: Headers;
};

export type pileDensityResponse = (pileDensityResponseSuccess | pileDensityResponseError)

export const getPileDensityUrl = (code: string,
    params?: PileDensityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/piles/${code}/density?${stringifiedParams}` : `/api/piles/${code}/density`
}

/**
 * Override a pile's density. It applies to the pile's latest results at once (tonnes
 * recomputed, the model's kept) and to every run persisted after; None restores the model.
 * @summary Pile Density
 */
export const pileDensity = async (code: string,
    densityIn: DensityIn,
    params?: PileDensityParams, options?: Parameters<typeof apiFetch>[1]): Promise<pileDensityResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<pileDensityResponse>(getPileDensityUrl(code,params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(densityIn)
  }
);}





export const getPileDensityMutationKey = () => ['pileDensity'] as const;

export const getPileDensityMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pileDensity>>, TError,PileDensityMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pileDensity>>, TError,PileDensityMutationVariables, TContext> => {

const mutationKey = getPileDensityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pileDensity>>, PileDensityMutationVariables> = (props) => {
          const {code,data,params} = props ?? {};

          return  pileDensity(code,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PileDensityMutationResult = NonNullable<Awaited<ReturnType<typeof pileDensity>>>
    export type PileDensityMutationBody = DensityIn
    export type PileDensityMutationError = HTTPValidationError
    export type PileDensityMutationVariables = {code: string;data: DensityIn;params?: PileDensityParams}

    /**
 * @summary Pile Density
 */
export const usePileDensity = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pileDensity>>, TError,PileDensityMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pileDensity>>,
        TError,
        PileDensityMutationVariables,
        TContext
      > => {
      return useMutation(getPileDensityMutationOptions(options), queryClient);
    }

export type readyzResponse200 = {
  data: unknown
  status: 200
}

export type readyzResponseSuccess = (readyzResponse200) & {
  headers: Headers;
};
;

export type readyzResponse = (readyzResponseSuccess)

export const getReadyzUrl = () => {




  return `/api/readyz`
}

/**
 * @summary Readyz
 */
export const readyz = async ( options?: Parameters<typeof apiFetch>[1]): Promise<readyzResponse> => {

  return apiFetch<readyzResponse>(getReadyzUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReadyzQueryKey = () => {
    return [
    `/api/readyz`
    ] as const;
    }


export const getReadyzQueryOptions = <TData = Awaited<ReturnType<typeof readyz>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readyz>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadyzQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof readyz>>> = ({ signal }) => readyz({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readyz>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadyzQueryResult = NonNullable<Awaited<ReturnType<typeof readyz>>>
export type ReadyzQueryError = unknown


export function useReadyz<TData = Awaited<ReturnType<typeof readyz>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readyz>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readyz>>,
          TError,
          Awaited<ReturnType<typeof readyz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadyz<TData = Awaited<ReturnType<typeof readyz>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readyz>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readyz>>,
          TError,
          Awaited<ReturnType<typeof readyz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadyz<TData = Awaited<ReturnType<typeof readyz>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readyz>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Readyz
 */

export function useReadyz<TData = Awaited<ReturnType<typeof readyz>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readyz>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadyzQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type reclaimedCoalResponse200 = {
  data: ReclaimedOut[]
  status: 200
}

export type reclaimedCoalResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reclaimedCoalResponseSuccess = (reclaimedCoalResponse200) & {
  headers: Headers;
};
export type reclaimedCoalResponseError = (reclaimedCoalResponse422) & {
  headers: Headers;
};

export type reclaimedCoalResponse = (reclaimedCoalResponseSuccess | reclaimedCoalResponseError)

export const getReclaimedCoalUrl = (params: ReclaimedCoalParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reclaimed?${stringifiedParams}` : `/api/reclaimed`
}

/**
 * Per sweep interval and pile, the coal reclaimed with its lab values, oldest first (the
 * latest 500 rows of the period).
 * @summary Reclaimed Coal
 */
export const reclaimedCoal = async (params: ReclaimedCoalParams, options?: Parameters<typeof apiFetch>[1]): Promise<reclaimedCoalResponse> => {

  return apiFetch<reclaimedCoalResponse>(getReclaimedCoalUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReclaimedCoalQueryKey = (params?: ReclaimedCoalParams,) => {
    return [
    `/api/reclaimed`, ...(params ? [params] : [])
    ] as const;
    }


export const getReclaimedCoalQueryOptions = <TData = Awaited<ReturnType<typeof reclaimedCoal>>, TError = HTTPValidationError>(params: ReclaimedCoalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reclaimedCoal>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReclaimedCoalQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reclaimedCoal>>> = ({ signal }) => reclaimedCoal(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reclaimedCoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReclaimedCoalQueryResult = NonNullable<Awaited<ReturnType<typeof reclaimedCoal>>>
export type ReclaimedCoalQueryError = HTTPValidationError


export function useReclaimedCoal<TData = Awaited<ReturnType<typeof reclaimedCoal>>, TError = HTTPValidationError>(
 params: ReclaimedCoalParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reclaimedCoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reclaimedCoal>>,
          TError,
          Awaited<ReturnType<typeof reclaimedCoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReclaimedCoal<TData = Awaited<ReturnType<typeof reclaimedCoal>>, TError = HTTPValidationError>(
 params: ReclaimedCoalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reclaimedCoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reclaimedCoal>>,
          TError,
          Awaited<ReturnType<typeof reclaimedCoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReclaimedCoal<TData = Awaited<ReturnType<typeof reclaimedCoal>>, TError = HTTPValidationError>(
 params: ReclaimedCoalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reclaimedCoal>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reclaimed Coal
 */

export function useReclaimedCoal<TData = Awaited<ReturnType<typeof reclaimedCoal>>, TError = HTTPValidationError>(
 params: ReclaimedCoalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reclaimedCoal>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReclaimedCoalQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type reportsResponse200 = {
  data: PageReportOut
  status: 200
}

export type reportsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reportsResponseSuccess = (reportsResponse200) & {
  headers: Headers;
};
export type reportsResponseError = (reportsResponse422) & {
  headers: Headers;
};

export type reportsResponse = (reportsResponseSuccess | reportsResponseError)

export const getReportsUrl = (params?: ReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports?${stringifiedParams}` : `/api/reports`
}

/**
 * @summary Reports
 */
export const reports = async (params?: ReportsParams, options?: Parameters<typeof apiFetch>[1]): Promise<reportsResponse> => {

  return apiFetch<reportsResponse>(getReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReportsQueryKey = (params?: ReportsParams,) => {
    return [
    `/api/reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getReportsQueryOptions = <TData = Awaited<ReturnType<typeof reports>>, TError = HTTPValidationError>(params?: ReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reports>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reports>>> = ({ signal }) => reports(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsQueryResult = NonNullable<Awaited<ReturnType<typeof reports>>>
export type ReportsQueryError = HTTPValidationError


export function useReports<TData = Awaited<ReturnType<typeof reports>>, TError = HTTPValidationError>(
 params: undefined |  ReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reports>>,
          TError,
          Awaited<ReturnType<typeof reports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReports<TData = Awaited<ReturnType<typeof reports>>, TError = HTTPValidationError>(
 params?: ReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reports>>,
          TError,
          Awaited<ReturnType<typeof reports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReports<TData = Awaited<ReturnType<typeof reports>>, TError = HTTPValidationError>(
 params?: ReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reports>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reports
 */

export function useReports<TData = Awaited<ReturnType<typeof reports>>, TError = HTTPValidationError>(
 params?: ReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reports>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createReportResponse201 = {
  data: ReportOut
  status: 201
}

export type createReportResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createReportResponseSuccess = (createReportResponse201) & {
  headers: Headers;
};
export type createReportResponseError = (createReportResponse422) & {
  headers: Headers;
};

export type createReportResponse = (createReportResponseSuccess | createReportResponseError)

export const getCreateReportUrl = () => {




  return `/api/reports`
}

/**
 * @summary Create Report
 */
export const createReport = async (reportIn: ReportIn, options?: Parameters<typeof apiFetch>[1]): Promise<createReportResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createReportResponse>(getCreateReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reportIn)
  }
);}





export const getCreateReportMutationKey = () => ['createReport'] as const;

export const getCreateReportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,CreateReportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,CreateReportMutationVariables, TContext> => {

const mutationKey = getCreateReportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReport>>, CreateReportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReportMutationResult = NonNullable<Awaited<ReturnType<typeof createReport>>>
    export type CreateReportMutationBody = ReportIn
    export type CreateReportMutationError = HTTPValidationError
    export type CreateReportMutationVariables = {data: ReportIn}

    /**
 * @summary Create Report
 */
export const useCreateReport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,CreateReportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createReport>>,
        TError,
        CreateReportMutationVariables,
        TContext
      > => {
      return useMutation(getCreateReportMutationOptions(options), queryClient);
    }

export type reportResponse200 = {
  data: ReportOut
  status: 200
}

export type reportResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reportResponseSuccess = (reportResponse200) & {
  headers: Headers;
};
export type reportResponseError = (reportResponse422) & {
  headers: Headers;
};

export type reportResponse = (reportResponseSuccess | reportResponseError)

export const getReportUrl = (reportId: number,) => {




  return `/api/reports/${reportId}`
}

/**
 * @summary Report
 */
export const report = async (reportId: number, options?: Parameters<typeof apiFetch>[1]): Promise<reportResponse> => {

  return apiFetch<reportResponse>(getReportUrl(reportId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReportQueryKey = (reportId: number,) => {
    return [
    `/api/reports/${reportId}`
    ] as const;
    }


export const getReportQueryOptions = <TData = Awaited<ReturnType<typeof report>>, TError = HTTPValidationError>(reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof report>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportQueryKey(reportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof report>>> = ({ signal }) => report(reportId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: reportId !== null && reportId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof report>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportQueryResult = NonNullable<Awaited<ReturnType<typeof report>>>
export type ReportQueryError = HTTPValidationError


export function useReport<TData = Awaited<ReturnType<typeof report>>, TError = HTTPValidationError>(
 reportId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof report>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof report>>,
          TError,
          Awaited<ReturnType<typeof report>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReport<TData = Awaited<ReturnType<typeof report>>, TError = HTTPValidationError>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof report>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof report>>,
          TError,
          Awaited<ReturnType<typeof report>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReport<TData = Awaited<ReturnType<typeof report>>, TError = HTTPValidationError>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof report>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Report
 */

export function useReport<TData = Awaited<ReturnType<typeof report>>, TError = HTTPValidationError>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof report>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportQueryOptions(reportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type reportFileResponse200 = {
  data: Blob
  status: 200
}

export type reportFileResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reportFileResponseSuccess = (reportFileResponse200) & {
  headers: Headers;
};
export type reportFileResponseError = (reportFileResponse422) & {
  headers: Headers;
};

export type reportFileResponse = (reportFileResponseSuccess | reportFileResponseError)

export const getReportFileUrl = (reportId: number,
    fmt: 'xlsx' | 'pdf',) => {




  return `/api/reports/${reportId}/${fmt}`
}

/**
 * @summary Report File
 */
export const reportFile = async (reportId: number,
    fmt: 'xlsx' | 'pdf', options?: Parameters<typeof apiFetch>[1]): Promise<reportFileResponse> => {

  return apiFetch<reportFileResponse>(getReportFileUrl(reportId,fmt),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReportFileQueryKey = (reportId: number,
    fmt: 'xlsx' | 'pdf',) => {
    return [
    `/api/reports/${reportId}/${fmt}`
    ] as const;
    }


export const getReportFileQueryOptions = <TData = Awaited<ReturnType<typeof reportFile>>, TError = HTTPValidationError>(reportId: number,
    fmt: 'xlsx' | 'pdf', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportFileQueryKey(reportId,fmt);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportFile>>> = ({ signal }) => reportFile(reportId,fmt, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: reportId !== null && reportId !== undefined && fmt !== null && fmt !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportFileQueryResult = NonNullable<Awaited<ReturnType<typeof reportFile>>>
export type ReportFileQueryError = HTTPValidationError


export function useReportFile<TData = Awaited<ReturnType<typeof reportFile>>, TError = HTTPValidationError>(
 reportId: number,
    fmt: 'xlsx' | 'pdf', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportFile>>,
          TError,
          Awaited<ReturnType<typeof reportFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportFile<TData = Awaited<ReturnType<typeof reportFile>>, TError = HTTPValidationError>(
 reportId: number,
    fmt: 'xlsx' | 'pdf', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportFile>>,
          TError,
          Awaited<ReturnType<typeof reportFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportFile<TData = Awaited<ReturnType<typeof reportFile>>, TError = HTTPValidationError>(
 reportId: number,
    fmt: 'xlsx' | 'pdf', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Report File
 */

export function useReportFile<TData = Awaited<ReturnType<typeof reportFile>>, TError = HTTPValidationError>(
 reportId: number,
    fmt: 'xlsx' | 'pdf', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportFileQueryOptions(reportId,fmt,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type runsResponse200 = {
  data: PageRunOut
  status: 200
}

export type runsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runsResponseSuccess = (runsResponse200) & {
  headers: Headers;
};
export type runsResponseError = (runsResponse422) & {
  headers: Headers;
};

export type runsResponse = (runsResponseSuccess | runsResponseError)

export const getRunsUrl = (params?: RunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/runs?${stringifiedParams}` : `/api/runs`
}

/**
 * Newest queued first.
 * @summary Runs
 */
export const runs = async (params?: RunsParams, options?: Parameters<typeof apiFetch>[1]): Promise<runsResponse> => {

  return apiFetch<runsResponse>(getRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRunsQueryKey = (params?: RunsParams,) => {
    return [
    `/api/runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getRunsQueryOptions = <TData = Awaited<ReturnType<typeof runs>>, TError = HTTPValidationError>(params?: RunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof runs>>> = ({ signal }) => runs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof runs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RunsQueryResult = NonNullable<Awaited<ReturnType<typeof runs>>>
export type RunsQueryError = HTTPValidationError


export function useRuns<TData = Awaited<ReturnType<typeof runs>>, TError = HTTPValidationError>(
 params: undefined |  RunsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof runs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runs>>,
          TError,
          Awaited<ReturnType<typeof runs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuns<TData = Awaited<ReturnType<typeof runs>>, TError = HTTPValidationError>(
 params?: RunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runs>>,
          TError,
          Awaited<ReturnType<typeof runs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRuns<TData = Awaited<ReturnType<typeof runs>>, TError = HTTPValidationError>(
 params?: RunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Runs
 */

export function useRuns<TData = Awaited<ReturnType<typeof runs>>, TError = HTTPValidationError>(
 params?: RunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRunsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type runResponse200 = {
  data: RunOut
  status: 200
}

export type runResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runResponseSuccess = (runResponse200) & {
  headers: Headers;
};
export type runResponseError = (runResponse422) & {
  headers: Headers;
};

export type runResponse = (runResponseSuccess | runResponseError)

export const getRunUrl = (runId: string,) => {




  return `/api/runs/${runId}`
}

/**
 * @summary Run
 */
export const run = async (runId: string, options?: Parameters<typeof apiFetch>[1]): Promise<runResponse> => {

  return apiFetch<runResponse>(getRunUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRunQueryKey = (runId: string,) => {
    return [
    `/api/runs/${runId}`
    ] as const;
    }


export const getRunQueryOptions = <TData = Awaited<ReturnType<typeof run>>, TError = HTTPValidationError>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof run>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRunQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof run>>> = ({ signal }) => run(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof run>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RunQueryResult = NonNullable<Awaited<ReturnType<typeof run>>>
export type RunQueryError = HTTPValidationError


export function useRun<TData = Awaited<ReturnType<typeof run>>, TError = HTTPValidationError>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof run>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof run>>,
          TError,
          Awaited<ReturnType<typeof run>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRun<TData = Awaited<ReturnType<typeof run>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof run>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof run>>,
          TError,
          Awaited<ReturnType<typeof run>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRun<TData = Awaited<ReturnType<typeof run>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof run>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Run
 */

export function useRun<TData = Awaited<ReturnType<typeof run>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof run>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRunQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type blocksResponse200 = {
  data: BlocksOut
  status: 200
}

export type blocksResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type blocksResponseSuccess = (blocksResponse200) & {
  headers: Headers;
};
export type blocksResponseError = (blocksResponse422) & {
  headers: Headers;
};

export type blocksResponse = (blocksResponseSuccess | blocksResponseError)

export const getBlocksUrl = (runId: string,) => {




  return `/api/runs/${runId}/blocks`
}

/**
 * @summary Blocks
 */
export const blocks = async (runId: string, options?: Parameters<typeof apiFetch>[1]): Promise<blocksResponse> => {

  return apiFetch<blocksResponse>(getBlocksUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBlocksQueryKey = (runId: string,) => {
    return [
    `/api/runs/${runId}/blocks`
    ] as const;
    }


export const getBlocksQueryOptions = <TData = Awaited<ReturnType<typeof blocks>>, TError = HTTPValidationError>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blocks>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBlocksQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof blocks>>> = ({ signal }) => blocks(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof blocks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BlocksQueryResult = NonNullable<Awaited<ReturnType<typeof blocks>>>
export type BlocksQueryError = HTTPValidationError


export function useBlocks<TData = Awaited<ReturnType<typeof blocks>>, TError = HTTPValidationError>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof blocks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof blocks>>,
          TError,
          Awaited<ReturnType<typeof blocks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBlocks<TData = Awaited<ReturnType<typeof blocks>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blocks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof blocks>>,
          TError,
          Awaited<ReturnType<typeof blocks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBlocks<TData = Awaited<ReturnType<typeof blocks>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blocks>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Blocks
 */

export function useBlocks<TData = Awaited<ReturnType<typeof blocks>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blocks>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBlocksQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type blocksGeometryResponse200ApplicationJson = {
  data: unknown
  status: 200
}

export type blocksGeometryResponse200ApplicationOctetStream = {
  data: Blob
  status: 200
}

export type blocksGeometryResponse304 = {
  data: void
  status: 304
}

export type blocksGeometryResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type blocksGeometryResponseSuccess = (blocksGeometryResponse200ApplicationJson | blocksGeometryResponse200ApplicationOctetStream) & {
  headers: Headers;
};
export type blocksGeometryResponseError = (blocksGeometryResponse304 | blocksGeometryResponse422) & {
  headers: Headers;
};

export type blocksGeometryResponse = (blocksGeometryResponseSuccess | blocksGeometryResponseError)

export const getBlocksGeometryUrl = (runId: string,
    params?: BlocksGeometryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/runs/${runId}/blocks/geometry?${stringifiedParams}` : `/api/runs/${runId}/blocks/geometry`
}

/**
 * @summary Blocks Geometry
 */
export const blocksGeometry = async (runId: string,
    params?: BlocksGeometryParams, options?: Parameters<typeof apiFetch>[1]): Promise<blocksGeometryResponse> => {

  return apiFetch<blocksGeometryResponse>(getBlocksGeometryUrl(runId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBlocksGeometryQueryKey = (runId: string,
    params?: BlocksGeometryParams,) => {
    return [
    `/api/runs/${runId}/blocks/geometry`, ...(params ? [params] : [])
    ] as const;
    }


export const getBlocksGeometryQueryOptions = <TData = Awaited<ReturnType<typeof blocksGeometry>>, TError = void | HTTPValidationError>(runId: string,
    params?: BlocksGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blocksGeometry>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBlocksGeometryQueryKey(runId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof blocksGeometry>>> = ({ signal }) => blocksGeometry(runId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof blocksGeometry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BlocksGeometryQueryResult = NonNullable<Awaited<ReturnType<typeof blocksGeometry>>>
export type BlocksGeometryQueryError = void | HTTPValidationError


export function useBlocksGeometry<TData = Awaited<ReturnType<typeof blocksGeometry>>, TError = void | HTTPValidationError>(
 runId: string,
    params: undefined |  BlocksGeometryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof blocksGeometry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof blocksGeometry>>,
          TError,
          Awaited<ReturnType<typeof blocksGeometry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBlocksGeometry<TData = Awaited<ReturnType<typeof blocksGeometry>>, TError = void | HTTPValidationError>(
 runId: string,
    params?: BlocksGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blocksGeometry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof blocksGeometry>>,
          TError,
          Awaited<ReturnType<typeof blocksGeometry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBlocksGeometry<TData = Awaited<ReturnType<typeof blocksGeometry>>, TError = void | HTTPValidationError>(
 runId: string,
    params?: BlocksGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blocksGeometry>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Blocks Geometry
 */

export function useBlocksGeometry<TData = Awaited<ReturnType<typeof blocksGeometry>>, TError = void | HTTPValidationError>(
 runId: string,
    params?: BlocksGeometryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blocksGeometry>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBlocksGeometryQueryOptions(runId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type cancelRunResponse200 = {
  data: RunBrief
  status: 200
}

export type cancelRunResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type cancelRunResponseSuccess = (cancelRunResponse200) & {
  headers: Headers;
};
export type cancelRunResponseError = (cancelRunResponse422) & {
  headers: Headers;
};

export type cancelRunResponse = (cancelRunResponseSuccess | cancelRunResponseError)

export const getCancelRunUrl = (runId: string,) => {




  return `/api/runs/${runId}/cancel`
}

/**
 * A queued run is cancelled at once; a running one is asked to stop (the worker ends it).
 * @summary Cancel Run
 */
export const cancelRun = async (runId: string, options?: Parameters<typeof apiFetch>[1]): Promise<cancelRunResponse> => {

  return apiFetch<cancelRunResponse>(getCancelRunUrl(runId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelRunMutationKey = () => ['cancelRun'] as const;

export const getCancelRunMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRun>>, TError,CancelRunMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelRun>>, TError,CancelRunMutationVariables, TContext> => {

const mutationKey = getCancelRunMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelRun>>, CancelRunMutationVariables> = (props) => {
          const {runId} = props ?? {};

          return  cancelRun(runId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelRunMutationResult = NonNullable<Awaited<ReturnType<typeof cancelRun>>>

    export type CancelRunMutationError = HTTPValidationError
    export type CancelRunMutationVariables = {runId: string}

    /**
 * @summary Cancel Run
 */
export const useCancelRun = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRun>>, TError,CancelRunMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelRun>>,
        TError,
        CancelRunMutationVariables,
        TContext
      > => {
      return useMutation(getCancelRunMutationOptions(options), queryClient);
    }

export type changesResponse200 = {
  data: ChangeOut[]
  status: 200
}

export type changesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type changesResponseSuccess = (changesResponse200) & {
  headers: Headers;
};
export type changesResponseError = (changesResponse422) & {
  headers: Headers;
};

export type changesResponse = (changesResponseSuccess | changesResponseError)

export const getChangesUrl = (runId: string,) => {




  return `/api/runs/${runId}/changes`
}

/**
 * @summary Changes
 */
export const changes = async (runId: string, options?: Parameters<typeof apiFetch>[1]): Promise<changesResponse> => {

  return apiFetch<changesResponse>(getChangesUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChangesQueryKey = (runId: string,) => {
    return [
    `/api/runs/${runId}/changes`
    ] as const;
    }


export const getChangesQueryOptions = <TData = Awaited<ReturnType<typeof changes>>, TError = HTTPValidationError>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangesQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof changes>>> = ({ signal }) => changes(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof changes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChangesQueryResult = NonNullable<Awaited<ReturnType<typeof changes>>>
export type ChangesQueryError = HTTPValidationError


export function useChanges<TData = Awaited<ReturnType<typeof changes>>, TError = HTTPValidationError>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof changes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof changes>>,
          TError,
          Awaited<ReturnType<typeof changes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChanges<TData = Awaited<ReturnType<typeof changes>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof changes>>,
          TError,
          Awaited<ReturnType<typeof changes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChanges<TData = Awaited<ReturnType<typeof changes>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Changes
 */

export function useChanges<TData = Awaited<ReturnType<typeof changes>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChangesQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type runPilesResponse200 = {
  data: PileObsOut[]
  status: 200
}

export type runPilesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runPilesResponseSuccess = (runPilesResponse200) & {
  headers: Headers;
};
export type runPilesResponseError = (runPilesResponse422) & {
  headers: Headers;
};

export type runPilesResponse = (runPilesResponseSuccess | runPilesResponseError)

export const getRunPilesUrl = (runId: string,
    params?: RunPilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/runs/${runId}/piles?${stringifiedParams}` : `/api/runs/${runId}/piles`
}

/**
 * @summary Run Piles
 */
export const runPiles = async (runId: string,
    params?: RunPilesParams, options?: Parameters<typeof apiFetch>[1]): Promise<runPilesResponse> => {

  return apiFetch<runPilesResponse>(getRunPilesUrl(runId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRunPilesQueryKey = (runId: string,
    params?: RunPilesParams,) => {
    return [
    `/api/runs/${runId}/piles`, ...(params ? [params] : [])
    ] as const;
    }


export const getRunPilesQueryOptions = <TData = Awaited<ReturnType<typeof runPiles>>, TError = HTTPValidationError>(runId: string,
    params?: RunPilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runPiles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRunPilesQueryKey(runId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof runPiles>>> = ({ signal }) => runPiles(runId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof runPiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RunPilesQueryResult = NonNullable<Awaited<ReturnType<typeof runPiles>>>
export type RunPilesQueryError = HTTPValidationError


export function useRunPiles<TData = Awaited<ReturnType<typeof runPiles>>, TError = HTTPValidationError>(
 runId: string,
    params: undefined |  RunPilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof runPiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runPiles>>,
          TError,
          Awaited<ReturnType<typeof runPiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunPiles<TData = Awaited<ReturnType<typeof runPiles>>, TError = HTTPValidationError>(
 runId: string,
    params?: RunPilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runPiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runPiles>>,
          TError,
          Awaited<ReturnType<typeof runPiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunPiles<TData = Awaited<ReturnType<typeof runPiles>>, TError = HTTPValidationError>(
 runId: string,
    params?: RunPilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runPiles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Run Piles
 */

export function useRunPiles<TData = Awaited<ReturnType<typeof runPiles>>, TError = HTTPValidationError>(
 runId: string,
    params?: RunPilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runPiles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRunPilesQueryOptions(runId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type sectorsResponse200 = {
  data: VolumeOut[]
  status: 200
}

export type sectorsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type sectorsResponseSuccess = (sectorsResponse200) & {
  headers: Headers;
};
export type sectorsResponseError = (sectorsResponse422) & {
  headers: Headers;
};

export type sectorsResponse = (sectorsResponseSuccess | sectorsResponseError)

export const getSectorsUrl = (runId: string,) => {




  return `/api/runs/${runId}/sectors`
}

/**
 * @summary Sectors
 */
export const sectors = async (runId: string, options?: Parameters<typeof apiFetch>[1]): Promise<sectorsResponse> => {

  return apiFetch<sectorsResponse>(getSectorsUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSectorsQueryKey = (runId: string,) => {
    return [
    `/api/runs/${runId}/sectors`
    ] as const;
    }


export const getSectorsQueryOptions = <TData = Awaited<ReturnType<typeof sectors>>, TError = HTTPValidationError>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sectors>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSectorsQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sectors>>> = ({ signal }) => sectors(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sectors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SectorsQueryResult = NonNullable<Awaited<ReturnType<typeof sectors>>>
export type SectorsQueryError = HTTPValidationError


export function useSectors<TData = Awaited<ReturnType<typeof sectors>>, TError = HTTPValidationError>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sectors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sectors>>,
          TError,
          Awaited<ReturnType<typeof sectors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSectors<TData = Awaited<ReturnType<typeof sectors>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sectors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sectors>>,
          TError,
          Awaited<ReturnType<typeof sectors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSectors<TData = Awaited<ReturnType<typeof sectors>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sectors>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sectors
 */

export function useSectors<TData = Awaited<ReturnType<typeof sectors>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sectors>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSectorsQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type volumesResponse200 = {
  data: VolumeOut[]
  status: 200
}

export type volumesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type volumesResponseSuccess = (volumesResponse200) & {
  headers: Headers;
};
export type volumesResponseError = (volumesResponse422) & {
  headers: Headers;
};

export type volumesResponse = (volumesResponseSuccess | volumesResponseError)

export const getVolumesUrl = (runId: string,
    params?: VolumesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/runs/${runId}/volumes?${stringifiedParams}` : `/api/runs/${runId}/volumes`
}

/**
 * @summary Volumes
 */
export const volumes = async (runId: string,
    params?: VolumesParams, options?: Parameters<typeof apiFetch>[1]): Promise<volumesResponse> => {

  return apiFetch<volumesResponse>(getVolumesUrl(runId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVolumesQueryKey = (runId: string,
    params?: VolumesParams,) => {
    return [
    `/api/runs/${runId}/volumes`, ...(params ? [params] : [])
    ] as const;
    }


export const getVolumesQueryOptions = <TData = Awaited<ReturnType<typeof volumes>>, TError = HTTPValidationError>(runId: string,
    params?: VolumesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof volumes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVolumesQueryKey(runId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof volumes>>> = ({ signal }) => volumes(runId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof volumes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VolumesQueryResult = NonNullable<Awaited<ReturnType<typeof volumes>>>
export type VolumesQueryError = HTTPValidationError


export function useVolumes<TData = Awaited<ReturnType<typeof volumes>>, TError = HTTPValidationError>(
 runId: string,
    params: undefined |  VolumesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof volumes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof volumes>>,
          TError,
          Awaited<ReturnType<typeof volumes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVolumes<TData = Awaited<ReturnType<typeof volumes>>, TError = HTTPValidationError>(
 runId: string,
    params?: VolumesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof volumes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof volumes>>,
          TError,
          Awaited<ReturnType<typeof volumes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVolumes<TData = Awaited<ReturnType<typeof volumes>>, TError = HTTPValidationError>(
 runId: string,
    params?: VolumesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof volumes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Volumes
 */

export function useVolumes<TData = Awaited<ReturnType<typeof volumes>>, TError = HTTPValidationError>(
 runId: string,
    params?: VolumesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof volumes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVolumesQueryOptions(runId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type rasterResponse200ApplicationJson = {
  data: unknown
  status: 200
}

export type rasterResponse200ApplicationOctetStream = {
  data: Blob
  status: 200
}

export type rasterResponse304 = {
  data: void
  status: 304
}

export type rasterResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type rasterResponseSuccess = (rasterResponse200ApplicationJson | rasterResponse200ApplicationOctetStream) & {
  headers: Headers;
};
export type rasterResponseError = (rasterResponse304 | rasterResponse422) & {
  headers: Headers;
};

export type rasterResponse = (rasterResponseSuccess | rasterResponseError)

export const getRasterUrl = (runId: string,
    kind: 'dem' | 'dod' | 'quality' | 'classes',
    params?: RasterParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/runs/${runId}/${kind}.bin?${stringifiedParams}` : `/api/runs/${runId}/${kind}.bin`
}

/**
 * @summary Raster
 */
export const raster = async (runId: string,
    kind: 'dem' | 'dod' | 'quality' | 'classes',
    params?: RasterParams, options?: Parameters<typeof apiFetch>[1]): Promise<rasterResponse> => {

  return apiFetch<rasterResponse>(getRasterUrl(runId,kind,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRasterQueryKey = (runId: string,
    kind: 'dem' | 'dod' | 'quality' | 'classes',
    params?: RasterParams,) => {
    return [
    `/api/runs/${runId}/${kind}.bin`, ...(params ? [params] : [])
    ] as const;
    }


export const getRasterQueryOptions = <TData = Awaited<ReturnType<typeof raster>>, TError = void | HTTPValidationError>(runId: string,
    kind: 'dem' | 'dod' | 'quality' | 'classes',
    params?: RasterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raster>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRasterQueryKey(runId,kind,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof raster>>> = ({ signal }) => raster(runId,kind,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof raster>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RasterQueryResult = NonNullable<Awaited<ReturnType<typeof raster>>>
export type RasterQueryError = void | HTTPValidationError


export function useRaster<TData = Awaited<ReturnType<typeof raster>>, TError = void | HTTPValidationError>(
 runId: string,
    kind: 'dem' | 'dod' | 'quality' | 'classes',
    params: undefined |  RasterParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof raster>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof raster>>,
          TError,
          Awaited<ReturnType<typeof raster>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRaster<TData = Awaited<ReturnType<typeof raster>>, TError = void | HTTPValidationError>(
 runId: string,
    kind: 'dem' | 'dod' | 'quality' | 'classes',
    params?: RasterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raster>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof raster>>,
          TError,
          Awaited<ReturnType<typeof raster>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRaster<TData = Awaited<ReturnType<typeof raster>>, TError = void | HTTPValidationError>(
 runId: string,
    kind: 'dem' | 'dod' | 'quality' | 'classes',
    params?: RasterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raster>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Raster
 */

export function useRaster<TData = Awaited<ReturnType<typeof raster>>, TError = void | HTTPValidationError>(
 runId: string,
    kind: 'dem' | 'dod' | 'quality' | 'classes',
    params?: RasterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raster>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRasterQueryOptions(runId,kind,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type confirmMetadataResponse200 = {
  data: CommandOut
  status: 200
}

export type confirmMetadataResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type confirmMetadataResponseSuccess = (confirmMetadataResponse200) & {
  headers: Headers;
};
export type confirmMetadataResponseError = (confirmMetadataResponse422) & {
  headers: Headers;
};

export type confirmMetadataResponse = (confirmMetadataResponseSuccess | confirmMetadataResponseError)

export const getConfirmMetadataUrl = () => {




  return `/api/sensor/confirm-metadata`
}

/**
 * Accept the sensor's changed metadata (a new firmware, a new mode or a replaced sensor):
 * ingest records again (M7.5 C11). The intrinsics may have changed — check a sweep after.
 * @summary Confirm Metadata
 */
export const confirmMetadata = async (confirmMetadataIn: ConfirmMetadataIn, options?: Parameters<typeof apiFetch>[1]): Promise<confirmMetadataResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<confirmMetadataResponse>(getConfirmMetadataUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(confirmMetadataIn)
  }
);}





export const getConfirmMetadataMutationKey = () => ['confirmMetadata'] as const;

export const getConfirmMetadataMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmMetadata>>, TError,ConfirmMetadataMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmMetadata>>, TError,ConfirmMetadataMutationVariables, TContext> => {

const mutationKey = getConfirmMetadataMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmMetadata>>, ConfirmMetadataMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  confirmMetadata(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmMetadataMutationResult = NonNullable<Awaited<ReturnType<typeof confirmMetadata>>>
    export type ConfirmMetadataMutationBody = ConfirmMetadataIn
    export type ConfirmMetadataMutationError = HTTPValidationError
    export type ConfirmMetadataMutationVariables = {data: ConfirmMetadataIn}

    /**
 * @summary Confirm Metadata
 */
export const useConfirmMetadata = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmMetadata>>, TError,ConfirmMetadataMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmMetadata>>,
        TError,
        ConfirmMetadataMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmMetadataMutationOptions(options), queryClient);
    }

export type siteResponse200 = {
  data: SiteOut
  status: 200
}

export type siteResponseSuccess = (siteResponse200) & {
  headers: Headers;
};
;

export type siteResponse = (siteResponseSuccess)

export const getSiteUrl = () => {




  return `/api/site`
}

/**
 * @summary Site
 */
export const site = async ( options?: Parameters<typeof apiFetch>[1]): Promise<siteResponse> => {

  return apiFetch<siteResponse>(getSiteUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSiteQueryKey = () => {
    return [
    `/api/site`
    ] as const;
    }


export const getSiteQueryOptions = <TData = Awaited<ReturnType<typeof site>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof site>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof site>>> = ({ signal }) => site({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof site>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteQueryResult = NonNullable<Awaited<ReturnType<typeof site>>>
export type SiteQueryError = unknown


export function useSite<TData = Awaited<ReturnType<typeof site>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof site>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof site>>,
          TError,
          Awaited<ReturnType<typeof site>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSite<TData = Awaited<ReturnType<typeof site>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof site>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof site>>,
          TError,
          Awaited<ReturnType<typeof site>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSite<TData = Awaited<ReturnType<typeof site>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof site>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Site
 */

export function useSite<TData = Awaited<ReturnType<typeof site>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof site>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type stackersResponse200 = {
  data: Stacker[]
  status: 200
}

export type stackersResponseSuccess = (stackersResponse200) & {
  headers: Headers;
};
;

export type stackersResponse = (stackersResponseSuccess)

export const getStackersUrl = () => {




  return `/api/stackers`
}

/**
 * @summary Stackers
 */
export const stackers = async ( options?: Parameters<typeof apiFetch>[1]): Promise<stackersResponse> => {

  return apiFetch<stackersResponse>(getStackersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStackersQueryKey = () => {
    return [
    `/api/stackers`
    ] as const;
    }


export const getStackersQueryOptions = <TData = Awaited<ReturnType<typeof stackers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stackers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStackersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stackers>>> = ({ signal }) => stackers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stackers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StackersQueryResult = NonNullable<Awaited<ReturnType<typeof stackers>>>
export type StackersQueryError = unknown


export function useStackers<TData = Awaited<ReturnType<typeof stackers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stackers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stackers>>,
          TError,
          Awaited<ReturnType<typeof stackers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStackers<TData = Awaited<ReturnType<typeof stackers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stackers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stackers>>,
          TError,
          Awaited<ReturnType<typeof stackers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStackers<TData = Awaited<ReturnType<typeof stackers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stackers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stackers
 */

export function useStackers<TData = Awaited<ReturnType<typeof stackers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stackers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStackersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type statusResponse200 = {
  data: StatusOut
  status: 200
}

export type statusResponseSuccess = (statusResponse200) & {
  headers: Headers;
};
;

export type statusResponse = (statusResponseSuccess)

export const getStatusUrl = () => {




  return `/api/status`
}

/**
 * Domain health: heartbeats, the ingest view (sensor, position, PTP), the disk, the last
 * complete sweep's age, the queue. Without the database: what the heartbeat files say.
 * @summary Status
 */
export const status = async ( options?: Parameters<typeof apiFetch>[1]): Promise<statusResponse> => {

  return apiFetch<statusResponse>(getStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStatusQueryKey = () => {
    return [
    `/api/status`
    ] as const;
    }


export const getStatusQueryOptions = <TData = Awaited<ReturnType<typeof status>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof status>>> = ({ signal }) => status({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StatusQueryResult = NonNullable<Awaited<ReturnType<typeof status>>>
export type StatusQueryError = unknown


export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof status>>,
          TError,
          Awaited<ReturnType<typeof status>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof status>>,
          TError,
          Awaited<ReturnType<typeof status>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Status
 */

export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type sweepsResponse200 = {
  data: PageSweepOut
  status: 200
}

export type sweepsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type sweepsResponseSuccess = (sweepsResponse200) & {
  headers: Headers;
};
export type sweepsResponseError = (sweepsResponse422) & {
  headers: Headers;
};

export type sweepsResponse = (sweepsResponseSuccess | sweepsResponseError)

export const getSweepsUrl = (params?: SweepsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sweeps?${stringifiedParams}` : `/api/sweeps`
}

/**
 * Newest first; `t_from`/`t_to` bound `started_at` (ISO 8601).
 * @summary Sweeps
 */
export const sweeps = async (params?: SweepsParams, options?: Parameters<typeof apiFetch>[1]): Promise<sweepsResponse> => {

  return apiFetch<sweepsResponse>(getSweepsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSweepsQueryKey = (params?: SweepsParams,) => {
    return [
    `/api/sweeps`, ...(params ? [params] : [])
    ] as const;
    }


export const getSweepsQueryOptions = <TData = Awaited<ReturnType<typeof sweeps>>, TError = HTTPValidationError>(params?: SweepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sweeps>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSweepsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sweeps>>> = ({ signal }) => sweeps(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sweeps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SweepsQueryResult = NonNullable<Awaited<ReturnType<typeof sweeps>>>
export type SweepsQueryError = HTTPValidationError


export function useSweeps<TData = Awaited<ReturnType<typeof sweeps>>, TError = HTTPValidationError>(
 params: undefined |  SweepsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sweeps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sweeps>>,
          TError,
          Awaited<ReturnType<typeof sweeps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSweeps<TData = Awaited<ReturnType<typeof sweeps>>, TError = HTTPValidationError>(
 params?: SweepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sweeps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sweeps>>,
          TError,
          Awaited<ReturnType<typeof sweeps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSweeps<TData = Awaited<ReturnType<typeof sweeps>>, TError = HTTPValidationError>(
 params?: SweepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sweeps>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sweeps
 */

export function useSweeps<TData = Awaited<ReturnType<typeof sweeps>>, TError = HTTPValidationError>(
 params?: SweepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sweeps>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSweepsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type abortResponse200 = {
  data: CommandOut
  status: 200
}

export type abortResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type abortResponseSuccess = (abortResponse200) & {
  headers: Headers;
};
export type abortResponseError = (abortResponse422) & {
  headers: Headers;
};

export type abortResponse = (abortResponseSuccess | abortResponseError)

export const getAbortUrl = () => {




  return `/api/sweeps/abort`
}

/**
 * End the recording in progress as `aborted_operator` (process it later as a partial).
 * @summary Abort
 */
export const abort = async (stackerIn: StackerIn, options?: Parameters<typeof apiFetch>[1]): Promise<abortResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<abortResponse>(getAbortUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stackerIn)
  }
);}





export const getAbortMutationKey = () => ['abort'] as const;

export const getAbortMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof abort>>, TError,AbortMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof abort>>, TError,AbortMutationVariables, TContext> => {

const mutationKey = getAbortMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof abort>>, AbortMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  abort(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AbortMutationResult = NonNullable<Awaited<ReturnType<typeof abort>>>
    export type AbortMutationBody = StackerIn
    export type AbortMutationError = HTTPValidationError
    export type AbortMutationVariables = {data: StackerIn}

    /**
 * @summary Abort
 */
export const useAbort = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof abort>>, TError,AbortMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof abort>>,
        TError,
        AbortMutationVariables,
        TContext
      > => {
      return useMutation(getAbortMutationOptions(options), queryClient);
    }

export type requestSweepResponse201 = {
  data: EventOut
  status: 201
}

export type requestSweepResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type requestSweepResponseSuccess = (requestSweepResponse201) & {
  headers: Headers;
};
export type requestSweepResponseError = (requestSweepResponse422) & {
  headers: Headers;
};

export type requestSweepResponse = (requestSweepResponseSuccess | requestSweepResponseError)

export const getRequestSweepUrl = () => {




  return `/api/sweeps/request`
}

/**
 * Ask the stacker driver for a sweep (a `sweep_requested` event the dashboard shows).
 * @summary Request Sweep
 */
export const requestSweep = async (sweepRequestIn: SweepRequestIn, options?: Parameters<typeof apiFetch>[1]): Promise<requestSweepResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<requestSweepResponse>(getRequestSweepUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sweepRequestIn)
  }
);}





export const getRequestSweepMutationKey = () => ['requestSweep'] as const;

export const getRequestSweepMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestSweep>>, TError,RequestSweepMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestSweep>>, TError,RequestSweepMutationVariables, TContext> => {

const mutationKey = getRequestSweepMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestSweep>>, RequestSweepMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestSweep(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestSweepMutationResult = NonNullable<Awaited<ReturnType<typeof requestSweep>>>
    export type RequestSweepMutationBody = SweepRequestIn
    export type RequestSweepMutationError = HTTPValidationError
    export type RequestSweepMutationVariables = {data: SweepRequestIn}

    /**
 * @summary Request Sweep
 */
export const useRequestSweep = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestSweep>>, TError,RequestSweepMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestSweep>>,
        TError,
        RequestSweepMutationVariables,
        TContext
      > => {
      return useMutation(getRequestSweepMutationOptions(options), queryClient);
    }

export type triggerResponse200 = {
  data: CommandOut
  status: 200
}

export type triggerResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type triggerResponseSuccess = (triggerResponse200) & {
  headers: Headers;
};
export type triggerResponseError = (triggerResponse422) & {
  headers: Headers;
};

export type triggerResponse = (triggerResponseSuccess | triggerResponseError)

export const getTriggerUrl = () => {




  return `/api/sweeps/trigger`
}

/**
 * Start recording a sweep now (ingest acknowledges with the sweep's dedupe key).
 * @summary Trigger
 */
export const trigger = async (stackerIn: StackerIn, options?: Parameters<typeof apiFetch>[1]): Promise<triggerResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<triggerResponse>(getTriggerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stackerIn)
  }
);}





export const getTriggerMutationKey = () => ['trigger'] as const;

export const getTriggerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trigger>>, TError,TriggerMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof trigger>>, TError,TriggerMutationVariables, TContext> => {

const mutationKey = getTriggerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof trigger>>, TriggerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  trigger(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerMutationResult = NonNullable<Awaited<ReturnType<typeof trigger>>>
    export type TriggerMutationBody = StackerIn
    export type TriggerMutationError = HTTPValidationError
    export type TriggerMutationVariables = {data: StackerIn}

    /**
 * @summary Trigger
 */
export const useTrigger = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trigger>>, TError,TriggerMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof trigger>>,
        TError,
        TriggerMutationVariables,
        TContext
      > => {
      return useMutation(getTriggerMutationOptions(options), queryClient);
    }

export type sweepResponse200 = {
  data: SweepDetail
  status: 200
}

export type sweepResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type sweepResponseSuccess = (sweepResponse200) & {
  headers: Headers;
};
export type sweepResponseError = (sweepResponse422) & {
  headers: Headers;
};

export type sweepResponse = (sweepResponseSuccess | sweepResponseError)

export const getSweepUrl = (sweepId: string,) => {




  return `/api/sweeps/${sweepId}`
}

/**
 * @summary Sweep
 */
export const sweep = async (sweepId: string, options?: Parameters<typeof apiFetch>[1]): Promise<sweepResponse> => {

  return apiFetch<sweepResponse>(getSweepUrl(sweepId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSweepQueryKey = (sweepId: string,) => {
    return [
    `/api/sweeps/${sweepId}`
    ] as const;
    }


export const getSweepQueryOptions = <TData = Awaited<ReturnType<typeof sweep>>, TError = HTTPValidationError>(sweepId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sweep>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSweepQueryKey(sweepId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sweep>>> = ({ signal }) => sweep(sweepId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sweepId !== null && sweepId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sweep>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SweepQueryResult = NonNullable<Awaited<ReturnType<typeof sweep>>>
export type SweepQueryError = HTTPValidationError


export function useSweep<TData = Awaited<ReturnType<typeof sweep>>, TError = HTTPValidationError>(
 sweepId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sweep>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sweep>>,
          TError,
          Awaited<ReturnType<typeof sweep>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSweep<TData = Awaited<ReturnType<typeof sweep>>, TError = HTTPValidationError>(
 sweepId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sweep>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sweep>>,
          TError,
          Awaited<ReturnType<typeof sweep>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSweep<TData = Awaited<ReturnType<typeof sweep>>, TError = HTTPValidationError>(
 sweepId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sweep>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sweep
 */

export function useSweep<TData = Awaited<ReturnType<typeof sweep>>, TError = HTTPValidationError>(
 sweepId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sweep>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSweepQueryOptions(sweepId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type maskOverridesResponse201 = {
  data: RunBrief
  status: 201
}

export type maskOverridesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type maskOverridesResponseSuccess = (maskOverridesResponse201) & {
  headers: Headers;
};
export type maskOverridesResponseError = (maskOverridesResponse422) & {
  headers: Headers;
};

export type maskOverridesResponse = (maskOverridesResponseSuccess | maskOverridesResponseError)

export const getMaskOverridesUrl = (sweepId: string,) => {




  return `/api/sweeps/${sweepId}/mask-overrides`
}

/**
 * Machinery override ("that was coal" / "mask this"): reprocess the sweep with them.
 * @summary Mask Overrides
 */
export const maskOverrides = async (sweepId: string,
    maskOverridesIn: MaskOverridesIn, options?: Parameters<typeof apiFetch>[1]): Promise<maskOverridesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<maskOverridesResponse>(getMaskOverridesUrl(sweepId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(maskOverridesIn)
  }
);}





export const getMaskOverridesMutationKey = () => ['maskOverrides'] as const;

export const getMaskOverridesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof maskOverrides>>, TError,MaskOverridesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof maskOverrides>>, TError,MaskOverridesMutationVariables, TContext> => {

const mutationKey = getMaskOverridesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof maskOverrides>>, MaskOverridesMutationVariables> = (props) => {
          const {sweepId,data} = props ?? {};

          return  maskOverrides(sweepId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MaskOverridesMutationResult = NonNullable<Awaited<ReturnType<typeof maskOverrides>>>
    export type MaskOverridesMutationBody = MaskOverridesIn
    export type MaskOverridesMutationError = HTTPValidationError
    export type MaskOverridesMutationVariables = {sweepId: string;data: MaskOverridesIn}

    /**
 * @summary Mask Overrides
 */
export const useMaskOverrides = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof maskOverrides>>, TError,MaskOverridesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof maskOverrides>>,
        TError,
        MaskOverridesMutationVariables,
        TContext
      > => {
      return useMutation(getMaskOverridesMutationOptions(options), queryClient);
    }

export type processPartialResponse201 = {
  data: RunBrief
  status: 201
}

export type processPartialResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type processPartialResponseSuccess = (processPartialResponse201) & {
  headers: Headers;
};
export type processPartialResponseError = (processPartialResponse422) & {
  headers: Headers;
};

export type processPartialResponse = (processPartialResponseSuccess | processPartialResponseError)

export const getProcessPartialUrl = (sweepId: string,) => {




  return `/api/sweeps/${sweepId}/process-partial`
}

/**
 * Queue a run for a sweep that was cut short (an operator's abort is only processed so).
 * @summary Process Partial
 */
export const processPartial = async (sweepId: string, options?: Parameters<typeof apiFetch>[1]): Promise<processPartialResponse> => {

  return apiFetch<processPartialResponse>(getProcessPartialUrl(sweepId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getProcessPartialMutationKey = () => ['processPartial'] as const;

export const getProcessPartialMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processPartial>>, TError,ProcessPartialMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof processPartial>>, TError,ProcessPartialMutationVariables, TContext> => {

const mutationKey = getProcessPartialMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processPartial>>, ProcessPartialMutationVariables> = (props) => {
          const {sweepId} = props ?? {};

          return  processPartial(sweepId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProcessPartialMutationResult = NonNullable<Awaited<ReturnType<typeof processPartial>>>

    export type ProcessPartialMutationError = HTTPValidationError
    export type ProcessPartialMutationVariables = {sweepId: string}

    /**
 * @summary Process Partial
 */
export const useProcessPartial = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processPartial>>, TError,ProcessPartialMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processPartial>>,
        TError,
        ProcessPartialMutationVariables,
        TContext
      > => {
      return useMutation(getProcessPartialMutationOptions(options), queryClient);
    }

export type trendsResponse200 = {
  data: TrendPoint[]
  status: 200
}

export type trendsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type trendsResponseSuccess = (trendsResponse200) & {
  headers: Headers;
};
export type trendsResponseError = (trendsResponse422) & {
  headers: Headers;
};

export type trendsResponse = (trendsResponseSuccess | trendsResponseError)

export const getTrendsUrl = (params?: TrendsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/trends?${stringifiedParams}` : `/api/trends`
}

/**
 * The current runs of a period (default: the last 7 days of sweeps), oldest first, with
 * the yard total, every pile, the attributed change and the density — one request for the
 * dashboard's trends (M6.5).
 * @summary Trends
 */
export const trends = async (params?: TrendsParams, options?: Parameters<typeof apiFetch>[1]): Promise<trendsResponse> => {

  return apiFetch<trendsResponse>(getTrendsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTrendsQueryKey = (params?: TrendsParams,) => {
    return [
    `/api/trends`, ...(params ? [params] : [])
    ] as const;
    }


export const getTrendsQueryOptions = <TData = Awaited<ReturnType<typeof trends>>, TError = HTTPValidationError>(params?: TrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTrendsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof trends>>> = ({ signal }) => trends(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TrendsQueryResult = NonNullable<Awaited<ReturnType<typeof trends>>>
export type TrendsQueryError = HTTPValidationError


export function useTrends<TData = Awaited<ReturnType<typeof trends>>, TError = HTTPValidationError>(
 params: undefined |  TrendsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trends>>,
          TError,
          Awaited<ReturnType<typeof trends>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTrends<TData = Awaited<ReturnType<typeof trends>>, TError = HTTPValidationError>(
 params?: TrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trends>>,
          TError,
          Awaited<ReturnType<typeof trends>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTrends<TData = Awaited<ReturnType<typeof trends>>, TError = HTTPValidationError>(
 params?: TrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Trends
 */

export function useTrends<TData = Awaited<ReturnType<typeof trends>>, TError = HTTPValidationError>(
 params?: TrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTrendsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type usersResponse200 = {
  data: UserOut[]
  status: 200
}

export type usersResponseSuccess = (usersResponse200) & {
  headers: Headers;
};
;

export type usersResponse = (usersResponseSuccess)

export const getUsersUrl = () => {




  return `/api/users`
}

/**
 * @summary Users
 */
export const users = async ( options?: Parameters<typeof apiFetch>[1]): Promise<usersResponse> => {

  return apiFetch<usersResponse>(getUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersQueryKey = () => {
    return [
    `/api/users`
    ] as const;
    }


export const getUsersQueryOptions = <TData = Awaited<ReturnType<typeof users>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof users>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof users>>> = ({ signal }) => users({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof users>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersQueryResult = NonNullable<Awaited<ReturnType<typeof users>>>
export type UsersQueryError = unknown


export function useUsers<TData = Awaited<ReturnType<typeof users>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof users>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof users>>,
          TError,
          Awaited<ReturnType<typeof users>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsers<TData = Awaited<ReturnType<typeof users>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof users>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof users>>,
          TError,
          Awaited<ReturnType<typeof users>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsers<TData = Awaited<ReturnType<typeof users>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof users>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Users
 */

export function useUsers<TData = Awaited<ReturnType<typeof users>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof users>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type addUserResponse201 = {
  data: UserOut
  status: 201
}

export type addUserResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type addUserResponseSuccess = (addUserResponse201) & {
  headers: Headers;
};
export type addUserResponseError = (addUserResponse422) & {
  headers: Headers;
};

export type addUserResponse = (addUserResponseSuccess | addUserResponseError)

export const getAddUserUrl = () => {




  return `/api/users`
}

/**
 * @summary Add User
 */
export const addUser = async (userIn: UserIn, options?: Parameters<typeof apiFetch>[1]): Promise<addUserResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<addUserResponse>(getAddUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userIn)
  }
);}





export const getAddUserMutationKey = () => ['addUser'] as const;

export const getAddUserMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addUser>>, TError,AddUserMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addUser>>, TError,AddUserMutationVariables, TContext> => {

const mutationKey = getAddUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addUser>>, AddUserMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddUserMutationResult = NonNullable<Awaited<ReturnType<typeof addUser>>>
    export type AddUserMutationBody = UserIn
    export type AddUserMutationError = HTTPValidationError
    export type AddUserMutationVariables = {data: UserIn}

    /**
 * @summary Add User
 */
export const useAddUser = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addUser>>, TError,AddUserMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addUser>>,
        TError,
        AddUserMutationVariables,
        TContext
      > => {
      return useMutation(getAddUserMutationOptions(options), queryClient);
    }

export type editUserResponse200 = {
  data: UserOut
  status: 200
}

export type editUserResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type editUserResponseSuccess = (editUserResponse200) & {
  headers: Headers;
};
export type editUserResponseError = (editUserResponse422) & {
  headers: Headers;
};

export type editUserResponse = (editUserResponseSuccess | editUserResponseError)

export const getEditUserUrl = (userId: number,) => {




  return `/api/users/${userId}`
}

/**
 * @summary Edit User
 */
export const editUser = async (userId: number,
    userEdit: UserEdit, options?: Parameters<typeof apiFetch>[1]): Promise<editUserResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<editUserResponse>(getEditUserUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userEdit)
  }
);}





export const getEditUserMutationKey = () => ['editUser'] as const;

export const getEditUserMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUser>>, TError,EditUserMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editUser>>, TError,EditUserMutationVariables, TContext> => {

const mutationKey = getEditUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editUser>>, EditUserMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  editUser(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditUserMutationResult = NonNullable<Awaited<ReturnType<typeof editUser>>>
    export type EditUserMutationBody = UserEdit
    export type EditUserMutationError = HTTPValidationError
    export type EditUserMutationVariables = {userId: number;data: UserEdit}

    /**
 * @summary Edit User
 */
export const useEditUser = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUser>>, TError,EditUserMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editUser>>,
        TError,
        EditUserMutationVariables,
        TContext
      > => {
      return useMutation(getEditUserMutationOptions(options), queryClient);
    }

export type versionResponse200 = {
  data: Version200
  status: 200
}

export type versionResponseSuccess = (versionResponse200) & {
  headers: Headers;
};
;

export type versionResponse = (versionResponseSuccess)

export const getVersionUrl = () => {




  return `/api/version`
}

/**
 * @summary Version
 */
export const version = async ( options?: Parameters<typeof apiFetch>[1]): Promise<versionResponse> => {

  return apiFetch<versionResponse>(getVersionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVersionQueryKey = () => {
    return [
    `/api/version`
    ] as const;
    }


export const getVersionQueryOptions = <TData = Awaited<ReturnType<typeof version>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof version>>> = ({ signal }) => version({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VersionQueryResult = NonNullable<Awaited<ReturnType<typeof version>>>
export type VersionQueryError = unknown


export function useVersion<TData = Awaited<ReturnType<typeof version>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof version>>,
          TError,
          Awaited<ReturnType<typeof version>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVersion<TData = Awaited<ReturnType<typeof version>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof version>>,
          TError,
          Awaited<ReturnType<typeof version>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVersion<TData = Awaited<ReturnType<typeof version>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Version
 */

export function useVersion<TData = Awaited<ReturnType<typeof version>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







